import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../../Service/Baseservice";
import './ConsultationEdit.css'
import "jspdf-autotable";
import dayjs from "dayjs";
import moment from "moment-timezone";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { useLocation } from "react-router-dom";
import UploadIcon from "../../../Assets/img/upload.png";
import { format, formatDistanceStrict } from "date-fns";
import Loading from "../../../Loading/loading";

const ConsultationEdit = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(null);
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [countryCodes, setCountryCodes] = useState([]);
  const [selectedCountryCodes, setSelectedCountryCodes] = useState({});
  const pageNumber = location.state?.pageNumber || 1;
  const languageId = location.state?.language_id || 1;
  const item = location.state?.consultationData || null;
  console.log("Received item:", item);
  const [startDate, setStartDate] = React.useState(dayjs());
  const [newStartDate, setNewStartDate] = React.useState(dayjs());
  const [startTime, setStartTime] = useState("");
  const [livePhoneErrors, setLivePhoneErrors] = useState({});
  const [liveEmailErrors, setLiveEmailErrors] = useState({});
  const [immigrationErr, setImmigrationErr] = useState("");
  const [consultationErr, setConsultationErr] = useState("");
  const [timeErr, setTimeErr] = useState("");
  const [endTime, setEndTime] = useState("");
  const [hadleType, setHandleType] = useState("");
  const [activeStartTime, setActiveStartTime] = useState(null);
  const [immigrationvalue, setimmigration] = useState();
  const [consultationtype, setConsultationType] = useState("");
  const [listimmigratongoal, setImmigrationGoal] = useState("");
  const [timeList, setTimeList] = useState([]);
  const [flag, setFlag] = useState(false);
  const [personalinformation, setPersonalInformation] = useState([]);
  const safePersonalInformation = Array.isArray(personalinformation)
    ? personalinformation
    : [];
  const [fieldOptions, setFieldOptions] = useState({});
  // const [serviceHeading, setServiceHeading] = useState("");
  const [serviceHeading, setServiceHeading] = useState(item?.heading || "");
  const [fieldMeta, setFieldMeta] = useState({});

  // ── per-field image upload loading tracker ─────────────────────────────────
  const [imageUploadLoading, setImageUploadLoading] = useState({});
  // ── tracks which image/signature fields are actually saved in the DB
  //    (vs. just uploaded locally and not yet submitted) ─────────────────────
  const [savedSignatures, setSavedSignatures] = useState({});

  // ── lightbox / preview popup state for signature images ────────────────
  const [imagePreviewModal, setImagePreviewModal] = useState({
    show: false,
    url: "",
    label: "",
  });

  const normalizeTime = (time) => {
    if (!time) return "";
    return time.length === 5 ? time : time.slice(0, 5);
  };

  const normalizeDate = (date) => {
    if (!date) return "";
    if (typeof date === "string") return date.slice(0, 10);
    if (dayjs.isDayjs(date)) return date.format("YYYY-MM-DD");
    return dayjs(date).format("YYYY-MM-DD");
  };
  const [popup, setPopup] = useState({
    show: false,
    title: "",
    message: "",
    type: "info",
  });
  const [popupbutton, setPopupbutton] = useState({
    show: false,
    title: "",
    message: "",
    type: "info",
  });
  const [paymentMessage, setPaymentMessage] = useState("");
  const [paymentImageUrl, setPaymentImageUrl] = useState(null);
  const [paymentImagePreview, setPaymentImagePreview] = useState(null);
  const [appointmentAmount, setAppointmentAmount] = useState("");
  const [amountReceived, setAmountReceived] = useState(false);
  const [paymentErrors, setPaymentErrors] = useState({});
  const [bookingErrors, setBookingErrors] = useState({});
  const [showNotesPopup, setShowNotesPopup] = useState(false);
  const [notesText, setNotesText] = useState("");
  const [notesError, setNotesError] = useState("");
  const [notesList, setNotesList] = useState([]);
  const [notesListLoading, setNotesListLoading] = useState(false);
  const amountStatus = admin?.payment_request_form?.[0]?.amount_status;
  const getSelectedOptionValue = (sectionsLabelsId, selectedValue) => {
    if (!selectedValue) return null;
    let selectedOptionValue = null;

    if (Array.isArray(personalinformation)) {
      personalinformation.forEach((section) => {
        const fieldsArray = section.data || section.fields || [];
        fieldsArray.forEach((item) => {
          if (item.sections_labels_id === sectionsLabelsId && item.options) {
            const matchedOption = item.options.find(
              (opt) => opt.option === selectedValue,
            );
            if (matchedOption) {
              selectedOptionValue = matchedOption.options_value;
            }
          }
        });
      });
    }
    return selectedOptionValue;
  };
  /* ================= ADMIN INIT ================= */
  useEffect(() => {
    if (!admin) return;
    setHandleType(admin.consultation_type_id);
    setimmigration(admin.listofservice_id);
    if (admin.admin_date) setStartDate(dayjs(admin.admin_date));
    setStartTime(admin.start_time);
    setEndTime(admin.end_time);
    setActiveStartTime(admin.admin_start_time);
  }, [admin]);

  useEffect(() => {
    if (item) {
      setAdmin(item);
      if (item.heading) {
        setServiceHeading(item.heading);
      }
    }
  }, [item]);

  /* ================= PREFILL SECTIONS VALUES ================= */
  useEffect(() => {
    if (!item?.sections) return;

    // Get section headings from the stored map
    const sectionHeadings = window.sectionHeadingsMap || {};

    // Build sections with options from fieldOptions and preserve section_heading
    const sectionsWithOptions = item.sections.map((section) => {
      const fieldsArray = section.fields || section.data || [];
      return {
        ...section,
        // Preserve original section_heading from API or use from map
        section_heading:
          section.section_heading || sectionHeadings[section.sections_id] || "",
        fields: fieldsArray.map((field) => ({
          ...field,
          ...(fieldMeta[field.sections_labels_id] || {}),
          // Get options from fieldOptions state, or fallback to field.options
          options:
            fieldOptions[field.sections_labels_id]?.length > 0
              ? fieldOptions[field.sections_labels_id]
              : field.options || [],
        })),
      };
    });

    setPersonalInformation(sectionsWithOptions);

    // Set values from existing data
    const values = {};
    const savedMap = {};
    item.sections.forEach((section) => {
      const fieldsArray = section.fields || section.data || [];
      if (Array.isArray(fieldsArray)) {
        fieldsArray.forEach((field) => {
          let value = field.details || "";

          const inputType = normalizeInputType(field.input_type);
          if (inputType === "table" && value && typeof value === "string") {
            try {
              value = JSON.parse(value);
            } catch (e) {
              console.error("Failed to parse table data:", e);
              value = [];
            }
          }

          if (inputType === "checkbox" && value && typeof value === "string") {
            try {
              const parsed = JSON.parse(value);
              if (Array.isArray(parsed)) {
                value = parsed;
              } else {
                value = value
                  .split(",")
                  .map((v) => v.trim())
                  .filter(Boolean);
              }
            } catch (e) {
              value = value
                .split(",")
                .map((v) => v.trim())
                .filter(Boolean);
            }
          }

          values[field.sections_labels_id] = value;

          // ── image/signature fields that already have a stored value
          //    (came from the server) are considered "saved" ─────────────
          if (inputType === "image" && value) {
            savedMap[field.sections_labels_id] = true;
          }
        });
      }
    });
    setPersonalInformationValues(values);
    setSavedSignatures(savedMap);
    // Prefill country codes for phoneno fields
    const phoneDefaults = {};
    item.sections.forEach((section) => {
      const fieldsArray = section.fields || section.data || [];
      fieldsArray.forEach((field) => {
        const inputType = normalizeInputType(field.input_type);
        if (inputType === "phoneno" && field.country_id) {
          phoneDefaults[field.sections_labels_id] = {
            country_id: field.country_id,
          };
        }
      });
    });
    if (Object.keys(phoneDefaults).length > 0) {
      setSelectedCountryCodes(phoneDefaults);
    }
  }, [item, fieldOptions, fieldMeta]);
  /* ================= FETCH ================= */
  useEffect(() => {
    if (startDate && hadleType) bookingList();
  }, [startDate, hadleType]);

  useEffect(() => {
    if (id) {
      webListOfService();
    }
  }, [id]);


  useEffect(() => {
    API.post("countryDropdown/webCondition", { language_id: 1 })
      .then((res) => {
        if (res.data.success === true) {
          setCountryCodes(res.data.data || []);
        }
      })
      .catch((err) => console.error("Country codes fetch error:", err));
  }, []);

  useEffect(() => {
    if (immigrationvalue) {
      consultationType();
    }
  }, [immigrationvalue, languageId]);
  useEffect(() => {
    if (!item?.sections || !immigrationvalue) return;

    const fetchFieldOptions = async () => {
      setLoading(true);
      try {
        const req = {
          language_id: languageId,
          listofservice_id: immigrationvalue,
        };
        const res = await API.post("AdminSectionsLabelList1/condition", req);

        if (res.data.success && Array.isArray(res.data.data)) {
          const optionsMap = {};
          const fieldMetaMap = {};
          let heading = "";

          // Create a map of sections with their headings
          const sectionsHeadingMap = {};

          res.data.data.forEach((item) => {
            // Store service heading
            if (item.service_heading && !heading) {
              heading = item.service_heading;
            }

            // Store section headings
            const sections = item.sections || [];
            sections.forEach((section) => {
              // Store section heading by sections_id
              if (section.section_heading) {
                sectionsHeadingMap[section.sections_id] =
                  section.section_heading;
              }

              const fieldsArray = section.data || section.fields || [];
              fieldsArray.forEach((field) => {
                // ← ADD THIS: Store field metadata
                fieldMetaMap[field.sections_labels_id] = {
                  label_mandatory: field.label_mandatory,
                  label: field.label,
                  input_type: field.input_type,
                  dependent_on: field.dependent_on,
                };

                if (
                  field.options &&
                  Array.isArray(field.options) &&
                  field.options.length > 0
                ) {
                  const activeOptions = field.options.filter(
                    (opt) => opt.active === 1,
                  );
                  optionsMap[field.sections_labels_id] =
                    activeOptions.length > 0 ? activeOptions : field.options;
                }
              });
            });
          });

          console.log("Field Options Map:", optionsMap);
          console.log("Section Headings Map:", sectionsHeadingMap);
          console.log("Field Meta Map:", fieldMetaMap);

          setFieldOptions(optionsMap);
          setFieldMeta(fieldMetaMap);
          // setServiceHeading(heading);
          if (!serviceHeading) {
            setServiceHeading(heading);
          }
          window.sectionHeadingsMap = sectionsHeadingMap;
        }
      } catch (error) {
        console.error("Error fetching field options:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFieldOptions();
  }, [immigrationvalue, languageId, item?.sections]);
  const consultationType = () => {
    let req = {
      language_id: languageId,
      listofservice_id: immigrationvalue,
    };

    API.post("ConsultationTypeListservice/webCondition", req).then((res) => {
      if (res.data.success === true && Array.isArray(res.data.data)) {
        setConsultationType(res.data.data);
      } else {
        setConsultationType([]);
      }
    });
  };

  const webListOfService = () => {
    setLoading(true);
    API.post("weblistofservice_list/webCondition", {
      language_id: languageId,
    }).then((res) => {
      if (res.data.success === true) {
        setImmigrationGoal(res.data.data.data);
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    if (hadleType && startDate) fetchTimeList(startDate.format("YYYY-MM-DD"));
  }, [hadleType, startDate]);

  const fetchTimeList = (selectedDate) => {
    const req = {
      consultation_type_id: hadleType,
      consultation_date: selectedDate,
      user_timezone: "America/Toronto",
    };
    API.post("consultationTimerSlotslist/webCondition", req)
      .then((res) => {
        if (res.data.success === true) setTimeList(res.data.data);
        else setTimeList([]);
      })
      .catch(() => setTimeList([]));
  };

  const [bookedRanges, setBookedRanges] = useState([]);

  const bookingList = () => {
    setBookedRanges([]);
    const req = {
      booking_date: startDate ? startDate.format("YYYY-MM-DD") : null,
      user_timezone: "America/Toronto",
    };
    API.post("consultationBokkinglist/webCondition", req).then((res) => {
      if (res.data.success && Array.isArray(res.data.data)) {
        if (res.data.data.length === 0) {
          setBookedRanges([]);
          return;
        }
        const ranges = res.data.data.map((item) => ({
          start: toMinutes(item.start_time),
          end: toMinutes(item.end_time),
          bookingId: item.consultation_booking_id,
        }));
        setBookedRanges(ranges);
      } else {
        setBookedRanges([]);
      }
    });
  };

  const isSlotDisabled = (slotStart, slotEnd) => {
    if (!slotStart || !slotEnd) return false;
    if (
      normalizeTime(slotStart) === normalizeTime(admin?.start_time) &&
      normalizeTime(slotEnd) === normalizeTime(admin?.end_time)
    )
      return false;
    const start = toMinutes(slotStart);
    const end = toMinutes(slotEnd);
    return bookedRanges.some((b) => {
      if (b.bookingId === admin?.consultation_booking_id) return false;
      return start < b.end && end > b.start;
    });
  };

  const toMinutes = (time) => {
    if (!time) return 0;
    const [h, m] = time.slice(0, 5).split(":");
    return Number(h) * 60 + Number(m);
  };

  const formatTime = (time) => time?.slice(0, 5);

  const convertTimezone = (item) => {
    const toTZ = admin?.user_timezone || "America/Toronto";
    const start = moment.tz(
      `${item.user_date} ${item.start_time}`,
      "YYYY-MM-DD HH:mm:ss",
      "America/Toronto",
    );
    const end = moment.tz(
      `${item.user_date} ${item.end_time}`,
      "YYYY-MM-DD HH:mm:ss",
      "America/Toronto",
    );
    return {
      startDate: start.clone().tz(toTZ).format("YYYY-MM-DD"),
      startTime: start.clone().tz(toTZ).format("HH:mm:ss"),
      endDate: end.clone().tz(toTZ).format("YYYY-MM-DD"),
      endTime: end.clone().tz(toTZ).format("HH:mm:ss"),
    };
  };

  const handleStartTime = (item) => {
    if (!item) return;
    setActiveStartTime(item.start_time);
    setFlag(true);
    setStartTime(convertTimezone(item).startTime);
    setEndTime(convertTimezone(item).endTime);
    setNewStartDate(convertTimezone(item).startDate);
    setTimeErr("");
  };

  const handleConsultationType = (e) => setHandleType(e.target.value);

  const calendarStyles = {
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    "& .MuiPickersCalendarHeader-root": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 12px",
      marginBottom: "8px",
      position: "relative",
    },
    "& .MuiPickersCalendarHeader-labelContainer": {
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
      pointerEvents: "none",
    },
    "& .MuiPickersCalendarHeader-label": { fontSize: "18px", fontWeight: 600 },
    "& .MuiPickersArrowSwitcher-root": {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
    },
    "& .MuiPickersArrowSwitcher-button": {
      width: "36px",
      height: "36px",
      borderRadius: "50%",
      backgroundColor: "#F1F3F4",
    },
    "& .MuiPickersArrowSwitcher-button:hover": { backgroundColor: "#E3E5E5" },
    "& .MuiDayCalendar-weekDayLabelContainer": {
      display: "grid",
      gridTemplateColumns: "repeat(7, 1fr)",
      width: "100%",
    },
    "& .MuiDayCalendar-weekDayLabel": {
      width: "100%",
      textAlign: "center",
      fontSize: "14px",
      fontWeight: 500,
    },
    "& .MuiDayCalendar-weekContainer": {
      display: "grid",
      gridTemplateColumns: "repeat(7, 1fr)",
      width: "100%",
      justifyItems: "center",
    },
    "& .MuiPickersDay-root": {
      width: "40px",
      height: "40px",
      margin: "auto",
      fontSize: "21px",
      borderRadius: "50%",
      backgroundColor: "transparent",
      border: "none",
    },
    "& .MuiPickersDay-root.Mui-selected": {
      backgroundColor: "#E3E5E5",
      color: "#72777A",
      border: "none",
    },
    "& .MuiPickersDay-root.Mui-selected:focus": {
      backgroundColor: "#E3E5E5",
      outline: "none",
    },
    "& .MuiPickersDay-root:focus": {
      backgroundColor: "transparent",
      outline: "none",
    },
    "& .MuiPickersDay-root:hover": {
      backgroundColor: "#E3E5E5",
      border: "none",
    },
    "& .MuiPickersDay-dayOutsideMonth": { visibility: "hidden" },
    "& .MuiPickersSlideTransition-root": { overflow: "hidden" },
  };

  const Immigration = (e) => setimmigration(e.target.value);

  /* ================= VALIDATION ================= */
  const handleNextStep = () => {
    let hasError = false;
    if (!immigrationvalue) {
      setImmigrationErr(
        languageId === 1
          ? "Please select immigration goal"
          : "Veuillez sélectionner l'objectif d'immigration",
      );
      hasError = true;
    } else setImmigrationErr("");

    if (!hadleType) {
      setConsultationErr(
        languageId === 1
          ? "Please select consultation type"
          : "Veuillez sélectionner le type de consultation",
      );
      hasError = true;
    } else setConsultationErr("");

    if (!startDate) hasError = true;

    if (!startTime || !endTime) {
      setTimeErr(
        languageId === 1
          ? "Please select a time slot"
          : "Veuillez sélectionner une plage horaire",
      );
      hasError = true;
    } else setTimeErr("");

    if (hasError) return;
    setStep(2);
  };
  const isHireInCanada = () => {
    const heading = serviceHeading || item?.heading || admin?.heading || "";
    const normalized = heading.trim().toLowerCase();
    return (
      normalized === "hire in canada" || normalized === "embaucher au canada"
    );
  };
  const emailRegex = /^[^\s@]+@[^\s@]+(\.[a-zA-Z]{2,})+$/;

  const validatePersonalInformation = () => {
    let errors = {};
    let isValid = true;

    console.log("=== STARTING VALIDATION ===");
    console.log(
      "Current personalInformationValues:",
      personalInformationValues,
    );
    console.log("personalinformation structure:", personalinformation);

    personalinformation.forEach((section) => {
      const fieldsArray = section.data || section.fields || [];
      if (!Array.isArray(fieldsArray)) return;

      fieldsArray.forEach((field) => {
        const isMandatory = field.label_mandatory === "Yes";
        const isRequired = field.is_required === "yes" || isMandatory;

        if (isRequired) {
          let value = personalInformationValues[field.sections_labels_id];
          if (value === undefined || value === null || value === "") {
            value = field.details || "";
          }

          const label = field.label;
          const isEmail =
            label?.toLowerCase().includes("email") ||
            label?.toLowerCase().includes("e-mail");

          console.log(
            `Validating field: ${label} (ID: ${field.sections_labels_id})`,
            {
              isMandatory: isMandatory,
              valueFromState:
                personalInformationValues[field.sections_labels_id],
              valueFromField: field.details,
              finalValue: value,
              hasValue: value && value !== "",
              type: typeof value,
            },
          );

          if (
            value === undefined ||
            value === null ||
            value === "" ||
            (Array.isArray(value) && value.length === 0)
          ) {
            errors[field.sections_labels_id] = `${label} is required`;
            isValid = false;
            console.log(`❌ Validation failed for ${label}: value is empty`);
          } else if (isEmail && !emailRegex.test(value)) {
            errors[field.sections_labels_id] =
              "Please enter a valid email address";
            isValid = false;
            console.log(
              `❌ Validation failed for ${label}: invalid email format`,
            );
          } else {
            console.log(`✅ Validation passed for ${label}`);
          }
        }
      });
    });

    setPersonalInformationErr(errors);
    console.log("Validation errors:", errors);
    console.log("Is valid:", isValid);
    return isValid;
  };

  const handleUpdateConsultation = async () => {
    let isValid = true;
    let errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+(\.[a-zA-Z]{2,})+$/;
    const phoneRegex = /^\d{6,12}$/;

    personalinformation.forEach((section) => {
      const fieldsArray = section.data || section.fields || [];
      fieldsArray.forEach((field) => {
        const value = personalInformationValues[field.sections_labels_id];
        const inputType = normalizeInputType(field.input_type);

        const meta = fieldMeta[field.sections_labels_id] || {};
        const labelMandatory = meta.label_mandatory || field.label_mandatory;
        const dependentOn = meta.dependent_on ?? field.dependent_on;

        // Resolve parent's options_value
        const parentValue = personalInformationValues[dependentOn];
        let parentOptionsValue = null;
        if (dependentOn && parentValue) {
          parentOptionsValue = getSelectedOptionValue(dependentOn, parentValue);
        }

        // Determine if field is disabled
        let isFieldDisabled = false;
        if (dependentOn) {
          if (!parentValue && parentValue !== 0) {
            isFieldDisabled = true;
          } else {
            isFieldDisabled = parentOptionsValue === "No";
          }
        }

        // ✅ Skip disabled fields entirely — no validation, no *
        if (isFieldDisabled) return;

        // ✅ Only validate mandatory fields
        const isRequired = labelMandatory === "Yes";
        if (!isRequired) return;

        // Validate by input type
        if (inputType === "email") {
          if (!value) {
            isValid = false;
            errors[field.sections_labels_id] =
              languageId === 1
                ? `${field.label} is required`
                : `${field.label} est requis`;
          } else if (!emailRegex.test(value)) {
            isValid = false;
            errors[field.sections_labels_id] =
              languageId === 1
                ? "Enter valid email"
                : "Entrez une adresse email valide";
          }
        } else if (inputType === "phoneno") {
          if (!value) {
            isValid = false;
            errors[field.sections_labels_id] =
              languageId === 1
                ? `${field.label} is required`
                : `${field.label} est requis`;
          } else if (!phoneRegex.test(value)) {
            isValid = false;
            errors[field.sections_labels_id] =
              languageId === 1
                ? "Enter valid phone number"
                : "Entrez un numéro de téléphone valide";
          } else if (!selectedCountryCodes[field.sections_labels_id]?.country_id) {
            isValid = false;
            errors[field.sections_labels_id] =
              languageId === 1
                ? "Please select a country code"
                : "Veuillez sélectionner un indicatif pays";
          }
        } else if (inputType === "checkbox_declaration") {
          if (!value) {
            isValid = false;
            errors[field.sections_labels_id] =
              languageId === 1
                ? "* Field is mandatory"
                : "* Le champ est obligatoire";
          }
        } else if (inputType === "table") {
          // ✅ Only one error path for table
          if (!Array.isArray(value) || value.length === 0) {
            isValid = false;
            errors[field.sections_labels_id] =
              languageId === 1
                ? "Please fill all table fields"
                : "Veuillez remplir tous les champs du tableau";
          } else {
            let hasEmptyCell = false;
            for (const row of value) {
              if (!row || typeof row !== "object") {
                hasEmptyCell = true;
                break;
              }
              for (const colValue of Object.values(row)) {
                if (
                  colValue === undefined ||
                  colValue === null ||
                  String(colValue).trim() === ""
                ) {
                  hasEmptyCell = true;
                  break;
                }
              }
              if (hasEmptyCell) break;
            }
            if (hasEmptyCell) {
              isValid = false;
              errors[field.sections_labels_id] =
                languageId === 1
                  ? "Please fill all table fields"
                  : "Veuillez remplir tous les champs du tableau";
            }
          }
        } else if (inputType === "checkbox") {
          if (!value || (Array.isArray(value) && value.length === 0)) {
            isValid = false;
            errors[field.sections_labels_id] =
              languageId === 1
                ? `${field.label} is required`
                : `${field.label} est requis`;
          }
        } else if (inputType === "image") {
          // image/signature — skip mandatory validation; re-upload is optional
        } else {
          if (
            value === undefined ||
            value === null ||
            value === "" ||
            (Array.isArray(value) && value.length === 0)
          ) {
            isValid = false;
            errors[field.sections_labels_id] =
              languageId === 1
                ? `${field.label} is required`
                : `${field.label} est requis`;
          }
        }
      });
    });

    setPersonalInformationErr(errors);

    if (!isValid) {
      const firstErrorId = Object.keys(errors)[0];
      if (firstErrorId) {
        // ✅ MATCH BookingIntakeForm: uses data-error-id attribute
        const el = document.querySelector(`[data-error-id="${firstErrorId}"]`);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }
      setPopup({
        show: true,
        title: languageId === 1 ? "Validation Error" : "Erreur de validation",
        message:
          languageId === 1
            ? "Please fill in all required fields."
            : "Veuillez remplir tous les champs obligatoires.",
        type: "error",
      });
      return;
    }

    try {
      const formData = [];

      safePersonalInformation.forEach((section) => {
        const fieldsArray = section.fields || section.data || [];

        if (Array.isArray(fieldsArray)) {
          fieldsArray.forEach((field) => {
            // Skip disabled dependent fields from submission
            const depMeta = fieldMeta[field.sections_labels_id] || {};
            const depOn = depMeta.dependent_on ?? field.dependent_on;
            if (depOn) {
              const parentVal = personalInformationValues[depOn];
              const parentOptVal = getSelectedOptionValue(depOn, parentVal);
              const isFieldDisabled =
                parentVal === undefined ||
                  parentVal === null ||
                  parentVal === ""
                  ? true
                  : parentOptVal === "No";
              if (isFieldDisabled) {
                // Send empty value so backend clears it
                formData.push({
                  sections_labels_id: field.sections_labels_id,
                  details: "",
                  ...(field.sections_values_id ? { sections_values_id: field.sections_values_id } : {}),
                });
                return;
              }
            }

            let value =
              personalInformationValues[field.sections_labels_id] ??
              field.details ??
              "";
            const inputType = normalizeInputType(field.input_type);

            if (inputType === "table") {
              if (Array.isArray(value) && value.length > 0) {
                const filteredData = value.filter(
                  (row) =>
                    row &&
                    Object.values(row).some(
                      (val) => val && val.toString().trim() !== "",
                    ),
                );
                value = JSON.stringify(filteredData);
              } else if (Array.isArray(value) && value.length === 0) {
                value = "[]";
              } else if (typeof value === "string" && value) {
                try {
                  JSON.parse(value);
                } catch (e) {
                  value = "[]";
                }
              } else {
                value = "[]";
              }
            } else if (Array.isArray(value)) {
              value = value.join(", ");
            } else if (
              value !== undefined &&
              value !== null &&
              typeof value !== "string"
            ) {
              value = String(value);
            } else if (value === undefined || value === null) {
              value = "";
            }

            const formEntry = {
              sections_labels_id: field.sections_labels_id,
              details: value,
            };

            if (normalizeInputType(field.input_type) === "phoneno") {
              formEntry.country_id =
                selectedCountryCodes[field.sections_labels_id]?.country_id || null;
            }

            if (field.sections_values_id) {
              formEntry.sections_values_id = field.sections_values_id;
            } else {
              const originalSection = item?.sections?.find((s) =>
                (s.fields || s.data)?.some(
                  (f) => f.sections_labels_id === field.sections_labels_id,
                ),
              );
              if (originalSection) {
                const originalField = (
                  originalSection.fields || originalSection.data
                )?.find(
                  (f) => f.sections_labels_id === field.sections_labels_id,
                );
                if (originalField?.sections_values_id) {
                  formEntry.sections_values_id =
                    originalField.sections_values_id;
                }
              }
            }

            formData.push(formEntry);
          });
        }
      });

      const payload = {
        language_id: languageId,
        consultation_booking_id: Number(id),
        sections_customer_id: admin?.sections_customer_id || null,
        user_timezone: admin?.user_timezone || "Asia/Calcutta",
        booking_date: flag ? newStartDate : startDate.format("YYYY-MM-DD"),
        start_time: startTime,
        end_time: endTime,
        consultation_type_id: Number(hadleType),
        listofservice_id: Number(immigrationvalue),
        form_data: formData,
      };

      console.log("Final Payload:", JSON.stringify(payload, null, 2));

      const res = await API.post(
        "userSectionsConsultationUpdate1/update",
        payload,
      );

      if (res.data.success) {
        // ── mark every image/signature field that currently has a value
        //    as "saved" now that the update succeeded ─────────────────────
        const newSaved = {};
        safePersonalInformation.forEach((section) => {
          const fieldsArray = section.fields || section.data || [];
          fieldsArray.forEach((field) => {
            if (normalizeInputType(field.input_type) === "image") {
              const val = personalInformationValues[field.sections_labels_id];
              if (val) newSaved[field.sections_labels_id] = true;
            }
          });
        });
        setSavedSignatures((prev) => ({ ...prev, ...newSaved }));

        setPopup({
          show: true,
          title: languageId === 1 ? "Success" : "Succès",
          message:
            languageId === 1
              ? "Consultation updated successfully"
              : "Consultation mise à jour avec succès",
          type: "success",
        });
      } else {
        setPopup({
          show: true,
          title: languageId === 1 ? "Error" : "Erreur",
          message:
            res.data?.message ||
            (languageId === 1
              ? "Update failed. Please try again."
              : "La mise à jour a échoué. Veuillez réessayer."),
          type: "error",
        });
      }
    } catch (error) {
      console.error("Update failed", error);
      setPopup({
        show: true,
        title: languageId === 1 ? "Error" : "Erreur",
        message:
          error?.response?.data?.message ||
          (languageId === 1
            ? "Something went wrong while updating the consultation."
            : "Une erreur s'est produite lors de la mise à jour de la consultation."),
        type: "error",
      });
    }
  };

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (err) => reject(err);
    });

  const { listofservice_id } = location.state || {};
  const [personalInformationValues, setPersonalInformationValues] = useState(
    {},
  );

  /* ─────────────────────────────────────────────────────────────────────────
     NEW: upload handler for signature / image fields
  ───────────────────────────────────────────────────────────────────────── */
  const handleSignatureUpload = async (fieldId, file) => {
    if (!file) return;
    setImageUploadLoading((prev) => ({ ...prev, [fieldId]: true }));
    try {
      const base64 = await fileToBase64(file);
      const res = await API.post("imageUpload/add", {
        name: "Signature",
        document: [{ name: file.name, type: file.type, base64 }],
      });
      const uploadedUrl = res.data.url?.[0] || "";
      if (uploadedUrl) {
        // Store as JSON array to match original format expected by backend
        handlePersonalInformation(fieldId, JSON.stringify([uploadedUrl]));
        // ── this image is only local until the form is submitted ─────────
        setSavedSignatures((prev) => ({ ...prev, [fieldId]: false }));
      }
    } catch (err) {
      console.error("Signature upload error:", err);
      setPopup({
        show: true,
        title: languageId === 1 ? "Error" : "Erreur",
        message: languageId === 1
          ? "Image upload failed. Please try again."
          : "Le téléchargement de l'image a échoué. Veuillez réessayer.",
        type: "error",
      });
    } finally {
      setImageUploadLoading((prev) => ({ ...prev, [fieldId]: false }));
    }
  };

  /* ─────────────────────────────────────────────────────────────────────────
     NEW: download handler for signature / image fields
  ───────────────────────────────────────────────────────────────────────── */
  const handleSignatureDownload = async (imageUrl, fieldLabel) => {
    if (!imageUrl) {
      setPopup({
        show: true,
        title: languageId === 1 ? "Error" : "Erreur",
        message: languageId === 1
          ? "No image available to download"
          : "Aucune image disponible à télécharger",
        type: "error",
      });
      return;
    }

    try {
      let cleanUrl = imageUrl;
      if (typeof cleanUrl === 'string') {
        cleanUrl = cleanUrl.replace(/^["']|["']$/g, '');

        if (cleanUrl.startsWith('[') || cleanUrl.startsWith('{')) {
          try {
            const parsed = JSON.parse(cleanUrl);
            if (Array.isArray(parsed) && parsed.length > 0) {
              cleanUrl = parsed[0];
            } else if (typeof parsed === 'string') {
              cleanUrl = parsed;
            }
          } catch (e) {
            // Not valid JSON, use as is
          }
        }
      }
      const urlObj = new URL(cleanUrl);
      urlObj.searchParams.set('t', Date.now().toString());
      const finalUrl = urlObj.toString();

      console.log('Downloading from URL:', finalUrl);

      const response = await fetch(finalUrl, {
        mode: 'cors',
        headers: {
          'Accept': 'image/*',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const safeName = (fieldLabel || 'signature')
        .replace(/[^a-z0-9]/gi, '_')
        .toLowerCase();

      let ext = 'png';
      const contentType = response.headers.get('content-type');
      if (contentType) {
        const typeMap = {
          'image/jpeg': 'jpg',
          'image/jpg': 'jpg',
          'image/png': 'png',
          'image/gif': 'gif',
          'image/webp': 'webp',
          'image/svg+xml': 'svg'
        };
        ext = typeMap[contentType] || 'png';
      } else {
        const urlExt = cleanUrl.split('.').pop().split('?')[0];
        if (urlExt && ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(urlExt.toLowerCase())) {
          ext = urlExt.toLowerCase();
        }
      }

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `${safeName}.${ext}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);

    } catch (err) {
      console.error('Download failed:', err);
      setPopup({
        show: true,
        title: languageId === 1 ? "Download Error" : "Erreur de téléchargement",
        message: languageId === 1
          ? "Failed to download image. Please try again."
          : "Échec du téléchargement de l'image. Veuillez réessayer.",
        type: "error",
      });
    }
  };

  const handlePersonalInformation = (id, value) => {
    setPersonalInformationValues((prev) => {
      const updated = { ...prev, [id]: value };

      const selectedOptionsValue = getSelectedOptionValue(id, value);
      const isNo = selectedOptionsValue === "No";

      if (isNo) {
        personalinformation.forEach((section) => {
          const fieldsArray = section.fields || section.data || [];
          fieldsArray.forEach((field) => {
            const dependentOn =
              fieldMeta[field.sections_labels_id]?.dependent_on ??
              field.dependent_on;
            if (String(dependentOn) === String(id)) {

            }
          });
        });
      }

      return updated;
    });

    setPersonalInformationErr((prev) => {
      const updatedErr = { ...prev, [id]: "" };

      const selectedOptionsValue = getSelectedOptionValue(id, value);
      if (selectedOptionsValue === "No") {
        personalinformation.forEach((section) => {
          const fieldsArray = section.fields || section.data || [];
          fieldsArray.forEach((field) => {
            const dependentOn =
              fieldMeta[field.sections_labels_id]?.dependent_on ??
              field.dependent_on;
            if (String(dependentOn) === String(id)) {
              updatedErr[field.sections_labels_id] = "";
            }
          });
        });
      }

      return updatedErr;
    });

    // Clear live phone error when dependent field resets it
    setLivePhoneErrors((prev) => {
      const updatedPhoneErr = { ...prev, [id]: "" };

      const selectedOptionsValue = getSelectedOptionValue(id, value);
      if (selectedOptionsValue === "No") {
        personalinformation.forEach((section) => {
          const fieldsArray = section.fields || section.data || [];
          fieldsArray.forEach((field) => {
            const dependentOn =
              fieldMeta[field.sections_labels_id]?.dependent_on ??
              field.dependent_on;
            if (String(dependentOn) === String(id)) {
              updatedPhoneErr[field.sections_labels_id] = "";
            }
          });
        });
      }

      return updatedPhoneErr;
    });

    // Clear live email error when dependent field resets it
    setLiveEmailErrors((prev) => {
      const updatedEmailErr = { ...prev, [id]: "" };

      const selectedOptionsValue = getSelectedOptionValue(id, value);
      if (selectedOptionsValue === "No") {
        personalinformation.forEach((section) => {
          const fieldsArray = section.fields || section.data || [];
          fieldsArray.forEach((field) => {
            const dependentOn =
              fieldMeta[field.sections_labels_id]?.dependent_on ??
              field.dependent_on;
            if (String(dependentOn) === String(id)) {
              updatedEmailErr[field.sections_labels_id] = "";
            }
          });
        });
      }

      return updatedEmailErr;
    });
  };

  const [personalInformationErr, setPersonalInformationErr] = useState({});

  const handleDateChange = (date) => {
    setStartDate(date);
    setStartTime("");
    setEndTime("");
  };

  useEffect(() => {
    if (!admin || !timeList.length || !startDate) return;
    const bookingDate = normalizeDate(admin.admin_date);
    const currentDate = normalizeDate(startDate);
    if (bookingDate === currentDate) {
      setActiveStartTime(admin.admin_start_time);
      setStartTime(admin.start_time);
      setEndTime(admin.end_time);
    } else {
      setActiveStartTime("");
      setStartTime("");
      setEndTime("");
    }
  }, [timeList, admin, startDate]);

  const resetPopupFormData = () => {
    setPaymentMessage("");
    setPaymentImagePreview(null);
    setPaymentImageUrl("");
    setPaymentErrors({});
    setAppointmentAmount("");
    setAmountReceived(false);
    setBookingErrors({});
  };

  const handlePaymentImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLoading(true);
    setPaymentImagePreview(URL.createObjectURL(file));
    fileToBase64(file).then((base64) => {
      API.post("imageUpload/add", {
        name: "Payment Request",
        document: [{ name: file.name, type: file.type, base64 }],
      })
        .then((res) => setPaymentImageUrl(res.data.url?.[0]))
        .catch((err) => console.error("Payment image upload error", err))
        .finally(() => setLoading(false));
    });
  };
  const getCustomerInfoFromSections = () => {
    let firstName = "";
    let lastName = "";
    let email = "";

    const sections = safePersonalInformation || [];

    // Priority 1: Check for "Authorized Contact Person" section (Hire in Canada)
    const authorizedContactSection = sections.find((sec) => {
      const title = sec.sections_titles?.toLowerCase() || "";
      return (
        title.includes("authorized contact person") ||
        title.includes("personne-ressource autorisée") ||
        title.includes("authorized")
      );
    });

    if (authorizedContactSection) {
      const fieldsArray =
        authorizedContactSection.fields || authorizedContactSection.data || [];

      fieldsArray.forEach((field) => {
        const label = field.label?.toLowerCase() || "";
        const val =
          personalInformationValues[field.sections_labels_id] ||
          field.details ||
          "";

        if (
          label.includes("business email") ||
          label.includes("email") ||
          label.includes("e-mail") ||
          label.includes("courriel")
        ) {
          email = val;
        }
        if (
          label.includes("first name") ||
          label.includes("prénom") ||
          label.includes("prenom")
        ) {
          firstName = val;
        }
        if (label.includes("last name") || label.includes("nom de famille")) {
          lastName = val;
        }
      });
    }

    // Priority 2: If not found in authorized contact section, check Family Sponsorship or Personal Information sections
    if (!firstName && !lastName && !email) {
      const isFamilySponsorship =
        admin?.heading === "Family Sponsorship" ||
        admin?.heading === "Parrainage familial";

      let targetSection = null;

      if (isFamilySponsorship) {
        targetSection = sections.find((sec) => {
          const title = sec.sections_titles?.toLowerCase() || "";
          return title.includes("applicant") || title.includes("demandeur");
        });
      } else {
        targetSection = sections.find((sec) => {
          const title = sec.sections_titles?.toLowerCase() || "";
          return (
            title.includes("personal") ||
            title.includes("renseignements personnels")
          );
        });
      }

      // fallback to first section if no specific section found
      if (!targetSection && sections.length > 0) {
        targetSection = sections[0];
      }

      if (targetSection) {
        const fieldsArray = targetSection.fields || targetSection.data || [];

        fieldsArray.forEach((field) => {
          const label = field.label?.toLowerCase() || "";
          const val =
            personalInformationValues[field.sections_labels_id] ||
            field.details ||
            "";

          if (
            label.includes("email") ||
            label.includes("e-mail") ||
            label.includes("courriel") ||
            label.includes("business email")
          ) {
            email = val;
          }
          if (
            label.includes("first name") ||
            label.includes("prénom") ||
            label.includes("prenom")
          ) {
            firstName = val;
          }
          if (label.includes("last name") || label.includes("nom de famille")) {
            lastName = val;
          }
          if (
            !firstName &&
            !lastName &&
            (label.includes("full name") || label.includes("nom et prénom"))
          ) {
            firstName = val;
          }
        });
      }
    }

    return {
      email,
      fullName:
        firstName && lastName
          ? `${firstName} ${lastName}`.trim()
          : firstName || lastName,
    };
  };

  const sendPaymentRequest = () => {
    let customerEmail = "";
    let customerName = "";

    const { email, fullName } = getCustomerInfoFromSections();
    customerEmail = email;
    customerName = fullName;

    if (!customerEmail && admin?.email) customerEmail = admin.email;
    if (!customerName && admin?.full_name) customerName = admin.full_name;

    if (!customerEmail) customerEmail = "";
    if (!customerName) customerName = "";

    const errors = {};
    if (!paymentMessage)
      errors.message =
        languageId === 1 ? "Message is required" : "Le message est requis";

    if (!paymentImageUrl)
      errors.image =
        languageId === 1
          ? "Please upload image"
          : "Veuillez télécharger une image";

    if (Object.keys(errors).length > 0) {
      setPaymentErrors(errors);
      return;
    }

    setPaymentErrors({});

    API.post("paymentRequestFormAdd/add", {
      consultation_booking_id: admin.consultation_booking_id,
      message: paymentMessage,
      image: paymentImageUrl,
      email: customerEmail,
      full_name: customerName,
    }).then((res) => {
      if (res.data.success) {
        resetPopupFormData();
        setPopupbutton({ show: false });
        setPopup({
          show: true,
          title: languageId === 1 ? "Success" : "Succès",
          message:
            languageId === 1
              ? "Payment request sent successfully"
              : "Demande de paiement envoyée avec succès",
          navigate: false,
        });
      }
    });
  };

  const handleConfirmPayment = () => {
    if (hadleType === 12 || hadleType === 13) {
      setLoading(true);

      let customerEmail = "";
      let customerName = "";

      const { email, fullName } = getCustomerInfoFromSections();
      customerEmail = email;
      customerName = fullName;

      if (!customerEmail && admin?.email) customerEmail = admin.email;
      if (!customerName && admin?.full_name) customerName = admin.full_name;

      if (!customerEmail) customerEmail = "";
      if (!customerName) customerName = "";

      const payload = {
        consultation_booking_id: admin?.consultation_booking_id,
        email: customerEmail,
        full_name: customerName,
        is_free_consultation: true,
      };

      API.post("SectionspaymentRequestAmountStatusUpdate1/update", payload)
        .then((res) => {
          if (res.data.success) {
            resetPopupFormData();
            setPopupbutton({ show: false });
            setPopup({
              show: true,
              title: languageId === 1 ? "Success" : "Succès",
              message:
                languageId === 1
                  ? "Booking confirmed successfully"
                  : "Rendez-vous confirmé avec succès",
              type: "success",
              navigate: false,
            });
          } else {
            setPopup({
              show: true,
              title: languageId === 1 ? "Error" : "Erreur",
              message:
                res.data?.message ||
                (languageId === 1
                  ? "Booking confirmation failed"
                  : "La confirmation de rendez-vous a échoué"),
              type: "error",
            });
          }
        })
        .catch((error) => {
          const errorMessage =
            error?.response?.data?.message ||
            error?.message ||
            (languageId === 1
              ? "Something went wrong"
              : "Quelque chose s'est mal passé");
          setPopup({
            show: true,
            title: languageId === 1 ? "Error" : "Erreur",
            message: errorMessage,
            type: "error",
          });
        })
        .finally(() => setLoading(false));
      return;
    }

    const errors = {};
    if (!appointmentAmount) {
      errors.amount =
        languageId === 1
          ? "Please enter appointment amount"
          : "Veuillez entrer le montant du rendez-vous";
    }
    if (!amountReceived) {
      errors.amountReceived =
        languageId === 1
          ? "Please confirm that the appointment amount is received"
          : "Veuillez confirmer que le montant du rendez-vous est reçu";
    }
    if (Object.keys(errors).length > 0) {
      setBookingErrors(errors);
      return;
    }

    setBookingErrors({});
    setLoading(true);

    let customerEmail = "";
    let customerName = "";
    const { email, fullName } = getCustomerInfoFromSections();
    customerEmail = email;
    customerName = fullName;

    if (!customerEmail && admin?.email) customerEmail = admin.email;
    if (!customerName && admin?.full_name) customerName = admin.full_name;
    if (!customerEmail) customerEmail = "";
    if (!customerName) customerName = "";

    const payload = {
      amount: appointmentAmount,
      payment_request_form_id: "",
      consultation_booking_id: admin?.consultation_booking_id,
      email: customerEmail,
      full_name: customerName,
    };

    API.post("SectionspaymentRequestAmountStatusUpdate/update", payload)
      .then((res) => {
        if (res.data.success) {
          resetPopupFormData();
          setPopupbutton({ show: false });
          setPopup({
            show: true,
            title: languageId === 1 ? "Success" : "Succès",
            message:
              languageId === 1
                ? "Payment confirmed successfully"
                : "Paiement confirmé avec succès",
            type: "success",
            navigate: false,
          });
        } else {
          setPopup({
            show: true,
            title: languageId === 1 ? "Error" : "Erreur",
            message:
              res.data?.message ||
              (languageId === 1
                ? "Payment confirmation failed"
                : "La confirmation de paiement a échoué"),
            type: "error",
          });
        }
      })
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          (languageId === 1
            ? "Something went wrong"
            : "Quelque chose s'est mal passé");
        setPopup({
          show: true,
          title: languageId === 1 ? "Error" : "Erreur",
          message: errorMessage,
          type: "error",
        });
      })
      .finally(() => setLoading(false));
  };
  const totalAppointmentAmount = Array.isArray(admin?.payment_request_form)
    ? admin.payment_request_form.reduce(
      (sum, item) => sum + (Number(item.amount) || 0),
      0,
    )
    : 0;

  const visiblePaymentRequests = Array.isArray(admin?.payment_request_form)
    ? admin.payment_request_form.filter((p) => p.message || p.image)
    : [];

  useEffect(() => {
    if (popupbutton.show) resetPopupFormData();
  }, [popupbutton.show]);

  const handleNote = () => {
    setNotesText("");
    setNotesError("");
    setShowNotesPopup(true);
  };

  const submitNotes = () => {
    if (!notesText.trim()) {
      setNotesError(
        languageId === 1 ? "Notes are required" : "Les notes sont requises",
      );
      return;
    }
    API.post("consultationNotesAdd/add", {
      consultation_booking_id: admin.consultation_booking_id,
      notes: notesText,
    })
      .then((res) => {
        if (res.data.success) {
          setShowNotesPopup(false);
          setNotesText("");
          handleNotesList();
          setPopup({
            show: true,
            type: "success",
            title: languageId === 1 ? "Success" : "Succès",
            message:
              languageId === 1
                ? "Notes added successfully"
                : "Notes ajoutées avec succès",
            navigate: false,
          });
        }
      })
      .catch((err) => console.error("Notes error:", err));
  };

  const handleNotesList = () => {
    setNotesListLoading(true);
    API.post("consultationNotesList/condition", {
      consultation_booking_id: admin.consultation_booking_id,
    })
      .then((res) => {
        if (res.data.success) setNotesList(res.data.data || []);
      })
      .catch((err) => console.error("Notes list error:", err))
      .finally(() => setNotesListLoading(false));
  };

  useEffect(() => {
    if (admin?.consultation_booking_id) handleNotesList();
  }, [admin?.consultation_booking_id]);

  const formatNoteDate = (date) => {
    const formattedDate = format(new Date(date), "MMMM d");
    const timeAgo = formatDistanceStrict(new Date(date), new Date(), {
      addSuffix: true,
    });
    return `${formattedDate} · ${timeAgo}`;
  };
  const handleTableChange = (sectionLabelId, rowIndex, columnName, value) => {
    setPersonalInformationValues((prev) => {
      const existingTable = prev[sectionLabelId] || [];
      const updatedTable = [...existingTable];

      // Get all column names for this table field
      let allColumns = [];
      personalinformation.forEach((section) => {
        const fieldsArray = section.fields || section.data || [];
        fieldsArray.forEach((field) => {
          if (field.sections_labels_id === sectionLabelId && field.options) {
            allColumns = field.options.map((opt) => opt.option);
          }
        });
      });

      // Initialize row with ALL columns as empty string if row doesn't exist yet
      if (!updatedTable[rowIndex]) {
        const emptyRow = {};
        allColumns.forEach((col) => {
          emptyRow[col] = "";
        });
        updatedTable[rowIndex] = emptyRow;
      }

      // Set the specific column value
      updatedTable[rowIndex] = {
        ...updatedTable[rowIndex],
        [columnName]: value,
      };

      return {
        ...prev,
        [sectionLabelId]: updatedTable,
      };
    });

    setPersonalInformationErr((prev) => {
      const currentTable = personalInformationValues[sectionLabelId] || [];

      let allFilled = true;
      for (const row of currentTable) {
        if (!row || typeof row !== "object") {
          allFilled = false;
          break;
        }
        for (const colValue of Object.values(row)) {
          if (
            colValue === undefined ||
            colValue === null ||
            String(colValue).trim() === ""
          ) {
            allFilled = false;
            break;
          }
        }
        if (!allFilled) break;
      }

      return {
        ...prev,
        [sectionLabelId]: allFilled ? "" : prev[sectionLabelId],
      };
    });
  };

  const normalizeInputType = (type = "") => {
    if (!type) return "input";
    const t = String(type).toLowerCase();

    if (["text", "texte"].includes(t)) return "text";
    if (["numbers", "nombres"].includes(t)) return "number";
    if (["text with numbers", "texte avec des chiffres"].includes(t))
      return "mixed";
    if (["radio_button", "bouton_radio"].includes(t)) return "radio";
    if (["drop_down", "dérouler"].includes(t)) return "dropdown";
    if (["checkbox", "case à cocher"].includes(t)) return "checkbox";
    if (["briefly_description", "brièvement_description"].includes(t))
      return "description";
    if (["email", "e-mail"].includes(t)) return "email";
    if (["phoneno", "numéro de téléphone"].includes(t)) return "phoneno";
    if (["checkbox declaration", "déclaration de case à cocher"].includes(t))
      return "checkbox_declaration";
    if (["table", "tableau"].includes(t)) return "table";

    if (
      [
        "date",
        "date_field",
        "champ_date",
        "datepicker",
        "previous date",
        "future date",
        "date précédente",
        "date future",
      ].includes(t)
    )
      return "date";
    if (["image", "signature"].includes(t)) return "image";
    return "input";
  };

  const renderFormField = (field, value, handleChange) => {
    const type = normalizeInputType(field.input_type);

    let isDisabled = false;
    // Use fieldMeta for dependent_on (fresher API data), fallback to field
    const depOn = fieldMeta[field.sections_labels_id]?.dependent_on ?? field.dependent_on;

    if (depOn) {
      const dependentValue = personalInformationValues[depOn];
      const parentOptionsValue = getSelectedOptionValue(depOn, dependentValue);

      if (!dependentValue && dependentValue !== 0) {
        isDisabled = true;
      } else {
        isDisabled = parentOptionsValue === "No";
      }
    }
    console.log(
      "Date field input_type:",
      field.label,
      "->",
      field.input_type,
      "->normalized:",
      type,
    );
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\+?[0-9]{7,15}$/;


    if (field.dependent_on) {
      const dependentValue = personalInformationValues[field.dependent_on];
      const parentOptionsValue = getSelectedOptionValue(
        field.dependent_on,
        dependentValue,
      );

      if (
        dependentValue === undefined ||
        dependentValue === null ||
        dependentValue === ""
      ) {
        isDisabled = true;
      } else {
        isDisabled = parentOptionsValue === "No";
      }
    }

    const commonProps = {
      disabled: isDisabled,
      style: {
        backgroundColor: isDisabled ? "#e9ecef" : "white",
        cursor: isDisabled ? "not-allowed" : "text",
        opacity: isDisabled ? 0.7 : 1,
      },
    };

    switch (type) {
      case "text":
        return (
          <input
            type="text"
            className={`form-control ${isDisabled ? "disabled-field" : ""}`}
            placeholder={field.placeholder || ""}
            value={value || ""}
            onKeyDown={(e) => {
              const allowedKeys = [
                "Backspace",
                "Delete",
                "Tab",
                "Enter",
                "Escape",
                "ArrowLeft",
                "ArrowRight",
                "ArrowUp",
                "ArrowDown",
                "Home",
                "End",
              ];
              const isLetter = /^[a-zA-Z]$/.test(e.key);
              // const isNumber = /^[0-9]$/.test(e.key);
              const isSpace = e.key === " ";
              const isCtrlCmd = e.ctrlKey || e.metaKey;
              if (
                !isLetter &&
                !isSpace &&
                !allowedKeys.includes(e.key) &&
                !isCtrlCmd
              ) {
                e.preventDefault();
              }
            }}
            onChange={(e) =>
              handleChange(field.sections_labels_id, e.target.value)
            }
            {...commonProps}
          />
        );
      case "number":
        return (
          <input
            type="text"
            className={`form-control ${isDisabled ? "disabled-field" : ""}`}
            placeholder={field.placeholder || ""}
            value={value || ""}
            onKeyDown={(e) => {
              const allowedKeys = [
                "Backspace",
                "Delete",
                "Tab",
                "Enter",
                "Escape",
                "ArrowLeft",
                "ArrowRight",
                "ArrowUp",
                "ArrowDown",
                "Home",
                "End",
              ];
              // const isLetter = /^[a-zA-Z]$/.test(e.key);
              const isNumber = /^[0-9]$/.test(e.key);
              const isSpace = e.key === " ";
              const isCtrlCmd = e.ctrlKey || e.metaKey;
              if (
                !isNumber &&
                !isSpace &&
                !allowedKeys.includes(e.key) &&
                !isCtrlCmd
              ) {
                e.preventDefault();
              }
            }}
            onChange={(e) =>
              handleChange(field.sections_labels_id, e.target.value)
            }
            {...commonProps}
          />
        );
      case "mixed":
        return (
          <input
            type="text"
            className={`form-control ${isDisabled ? "disabled-field" : ""}`}
            placeholder={field.placeholder || ""}
            value={value || ""}
            onKeyDown={(e) => {
              const allowedKeys = [
                "Backspace",
                "Delete",
                "Tab",
                "Enter",
                "Escape",
                "ArrowLeft",
                "ArrowRight",
                "ArrowUp",
                "ArrowDown",
                "Home",
                "End",
              ];
              const isLetter = /^[a-zA-Z]$/.test(e.key);

              const isNumber = /^[0-9]$/.test(e.key);

              const isSpace = e.key === " ";

              const isSpecial = ["-", ",", ".", "/"].includes(e.key);

              const isCtrlCmd = e.ctrlKey || e.metaKey;

              if (

                !isLetter &&

                !isNumber &&

                !isSpace &&

                !isSpecial &&

                !allowedKeys.includes(e.key) &&

                !isCtrlCmd

              ) {

                e.preventDefault();

              }

            }}
            onChange={(e) =>
              handleChange(field.sections_labels_id, e.target.value)
            }
            {...commonProps}
          />
        );

      case "radio":
        const allRadioOptions = field.options || [];
        if (allRadioOptions.length === 0) {
          return (
            <div className="text-warning">
              No options available for this field
            </div>
          );
        }
        return (
          <div
            className="d-flex flex-wrap gap-3"
            style={{
              pointerEvents: isDisabled ? "none" : "auto",
              opacity: isDisabled ? 0.6 : 1,
            }}
          >
            {allRadioOptions.map((opt) => (
              <div key={opt.sections_options_id} className="form-check">
                <input
                  type="radio"
                  id={`radio-${field.sections_labels_id}-${opt.sections_options_id}`} // ✅ ADD id
                  className="form-check-input"
                  name={`radio-${field.sections_labels_id}`}
                  value={opt.option}
                  checked={value === opt.option}
                  onChange={(e) =>
                    handleChange(field.sections_labels_id, e.target.value)
                  }
                  disabled={isDisabled}
                />
                <label
                  className="form-check-label"
                  htmlFor={`radio-${field.sections_labels_id}-${opt.sections_options_id}`} // ✅ ADD htmlFor
                >
                  {opt.option}
                </label>
              </div>
            ))}
          </div>
        );

      case "dropdown":
        const allDropdownOptions = field.options || [];
        if (allDropdownOptions.length === 0) {
          console.warn(`No options found for dropdown field: ${field.label}`);
          return (
            <div className="text-warning">
              No options available for this field
            </div>
          );
        }
        return (
          <select
            className={`form-select ${isDisabled ? "disabled-field" : ""}`}
            value={value || ""}
            onChange={(e) =>
              handleChange(field.sections_labels_id, e.target.value)
            }
            {...commonProps}
          >
            <option value="">
              {languageId === 1 ? "-- Select --" : "-- Sélectionner --"}
            </option>
            {allDropdownOptions.map((opt) => (
              <option key={opt.sections_options_id} value={opt.option}>
                {opt.option}
                {opt.active === 0 &&
                  ` (${languageId === 1 ? "Inactive" : "Inactif"})`}
              </option>
            ))}
          </select>
        );

      case "checkbox":
        const activeCheckboxOptions =
          field.options?.filter((opt) => opt.active === 1) || [];
        if (activeCheckboxOptions.length === 0 && field.options?.length > 0) {
          return (
            <div className="text-warning">
              No active options available for this field
            </div>
          );
        }
        return (
          <div
            className="d-flex flex-wrap gap-3"
            style={{
              pointerEvents: isDisabled ? "none" : "auto",
              opacity: isDisabled ? 0.6 : 1,
            }}
          >
            {activeCheckboxOptions.map((opt) => {
              const selectedValues = Array.isArray(value)
                ? value
                : value
                  ? value.split(",").map((v) => v.trim())
                  : [];

              return (
                <div key={opt.sections_options_id} className="form-check">
                  <input
                    type="checkbox"
                    id={`checkbox-${field.sections_labels_id}-${opt.sections_options_id}`} // ✅ ADD id
                    className="form-check-input"
                    value={opt.option}
                    checked={selectedValues.includes(opt.option)}
                    onChange={(e) => {
                      let updated = [...selectedValues];
                      if (e.target.checked) {
                        updated.push(opt.option);
                      } else {
                        updated = updated.filter((v) => v !== opt.option);
                      }
                      handleChange(field.sections_labels_id, updated);
                    }}
                    disabled={isDisabled}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`checkbox-${field.sections_labels_id}-${opt.sections_options_id}`} // ✅ ADD htmlFor
                  >
                    {opt.option}
                  </label>
                </div>
              );
            })}
          </div>
        );

      case "date":
        const dateRestriction = getDateRestriction(field.input_type);
        const todayDate = getTodayDate();
        const dateInputId = `date-${field.sections_labels_id}`;

        const getMaxDate = () => {
          return dateRestriction === "previous" ? todayDate : null;
        };

        const getMinDate = () => {
          return dateRestriction === "future" ? todayDate : null;
        };

        const getDatePlaceholder = () => {
          if (dateRestriction === "previous") {
            return languageId === 1
              ? "Select past date"
              : "Sélectionner une date passée";
          }
          if (dateRestriction === "future") {
            return languageId === 1
              ? "Select future date"
              : "Sélectionner une date future";
          }
          return languageId === 1 ? "Select date" : "Sélectionner une date";
        };

        const handleDateChangeWithValidation = (selectedDate) => {
          if (!selectedDate) {
            handleChange(field.sections_labels_id, selectedDate);
            return;
          }

          if (dateRestriction === "previous" && selectedDate > todayDate) {
            const errorMsg = getDateErrorMessage(dateRestriction, languageId);
            setPersonalInformationErr((prev) => ({
              ...prev,
              [field.sections_labels_id]: errorMsg,
            }));
            return;
          }

          if (dateRestriction === "future" && selectedDate < todayDate) {
            const errorMsg = getDateErrorMessage(dateRestriction, languageId);
            setPersonalInformationErr((prev) => ({
              ...prev,
              [field.sections_labels_id]: errorMsg,
            }));
            return;
          }

          setPersonalInformationErr((prev) => ({
            ...prev,
            [field.sections_labels_id]: "",
          }));

          handleChange(field.sections_labels_id, selectedDate);
        };

        return (
          <input
            type="date"
            id={dateInputId}
            className="form-control"
            value={value || ""}
            placeholder={getDatePlaceholder()}
            onChange={(e) => handleDateChangeWithValidation(e.target.value)}
            disabled={isDisabled}
            max={getMaxDate() || undefined}
            min={getMinDate() || undefined}
            style={{
              backgroundColor: isDisabled ? "#e9ecef" : "white",
              cursor: isDisabled ? "not-allowed" : "pointer",
              opacity: isDisabled ? 0.7 : 1,
            }}
          />
        );
      case "description":
        return (
          <textarea
            className={`textarea-control ${isDisabled ? "disabled-field" : ""}`}
            rows={5}
            value={value || ""}
            onChange={(e) =>
              handleChange(field.sections_labels_id, e.target.value)
            }
            {...commonProps}
          />
        );

      case "email":
        const emailRegexLive = /^[^\s@]+@[^\s@]+(\.[a-zA-Z]{2,})+$/;
        return (
          <>
            <input
              type="email"
              className={`form-control ${isDisabled ? "disabled-field" : ""}`}
              placeholder={field.placeholder || ""}
              value={value || ""}
              onChange={(e) => {
                const val = e.target.value;
                handleChange(field.sections_labels_id, val);

                // Live validation on every keystroke
                if (!val) {
                  setLiveEmailErrors((prev) => ({
                    ...prev,
                    [field.sections_labels_id]: "",
                  }));
                } else if (!emailRegexLive.test(val)) {
                  setLiveEmailErrors((prev) => ({
                    ...prev,
                    [field.sections_labels_id]:
                      languageId === 1
                        ? "Enter valid email (example@gmail.com)"
                        : "Entrez une adresse email valide (exemple@gmail.com)",
                  }));
                } else {
                  setLiveEmailErrors((prev) => ({
                    ...prev,
                    [field.sections_labels_id]: "",
                  }));
                }
              }}
              {...commonProps}
            />
            {liveEmailErrors[field.sections_labels_id] && (
              <small className="text-danger">
                {liveEmailErrors[field.sections_labels_id]}
              </small>
            )}
          </>
        );

      case "phoneno":
        const phoneRegexLive = /^\d{6,12}$/;
        const selectedCountryObj = countryCodes.find(
          (c) => String(c.country_id) === String(selectedCountryCodes[field.sections_labels_id]?.country_id)
        );
        const dropdownOpenKey = `phone_dropdown_${field.sections_labels_id}`;

        return (
          <>
            <div
              className={`phone-input-wrapper ${isDisabled ? "disabled-field" : ""}`}
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #ced4da",
                borderRadius: "6px",
                overflow: "visible",
                backgroundColor: isDisabled ? "#e9ecef" : "white",
                opacity: isDisabled ? 0.7 : 1,
                position: "relative",
              }}
            >
              {/* Custom Country Code Dropdown */}
              <div
                style={{ position: "relative", flexShrink: 0 }}
                onBlur={(e) => {
                  if (!e.currentTarget.contains(e.relatedTarget)) {
                    setPersonalInformationValues((prev) => ({
                      ...prev,
                      [dropdownOpenKey]: false,
                      [`${dropdownOpenKey}_search`]: "",
                    }));
                  }
                }}
              >
                <button
                  className="phoneno-btn"
                  type="button"
                  disabled={isDisabled}
                  onClick={() =>
                    setPersonalInformationValues((prev) => ({
                      ...prev,
                      [dropdownOpenKey]: !prev[dropdownOpenKey],
                    }))
                  }

                >
                  <span>{selectedCountryObj ? `+${selectedCountryObj.country_code}` : "+--"}</span>
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2 4L6 8L10 4" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>

                {/* Dropdown list */}
                {personalInformationValues[dropdownOpenKey] && !isDisabled && (
                  <div className="phoneno-code">
                    {/* Search input */}
                    <div
                      style={{
                        padding: "8px",
                        borderBottom: "1px solid #ced4da",
                        position: "sticky",
                        top: 0,
                        backgroundColor: "white",
                        zIndex: 1,
                      }}
                    >

                      <input
                        type="text"
                        autoFocus
                        placeholder={
                          languageId === 1
                            ? "Search country or code..."
                            : "Rechercher un pays ou un code..."
                        }
                        value={personalInformationValues[`${dropdownOpenKey}_search`] || ""}
                        onMouseDown={(e) => e.stopPropagation()}
                        onChange={(e) =>
                          setPersonalInformationValues((prev) => ({
                            ...prev,
                            [`${dropdownOpenKey}_search`]: e.target.value,
                          }))
                        }
                        style={{
                          width: "100%",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          padding: "6px 10px",
                          fontSize: "13px",
                          outline: "none",
                        }}
                      />
                    </div>

                    {/* Filtered list */}
                    <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                      {(() => {
                        const searchTerm = (
                          personalInformationValues[`${dropdownOpenKey}_search`] || ""
                        )
                          .toLowerCase()
                          .trim();

                        const filtered = countryCodes.filter((country) => {
                          if (!searchTerm) return true;
                          return (
                            country.country_name.toLowerCase().includes(searchTerm) ||
                            String(country.country_code).includes(searchTerm)
                          );
                        });

                        if (filtered.length === 0) {
                          return (
                            <div
                              style={{
                                padding: "12px 14px",
                                fontSize: "14px",
                                color: "#888",
                                textAlign: "center",
                              }}
                            >
                              No results found
                            </div>
                          );
                        }

                        return filtered.map((country) => (
                          <div
                            key={country.country_id}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              setSelectedCountryCodes((prev) => ({
                                ...prev,
                                [field.sections_labels_id]: { country_id: country.country_id },
                              }));
                              setPersonalInformationValues((prev) => ({
                                ...prev,
                                [dropdownOpenKey]: false,
                                [`${dropdownOpenKey}_search`]: "",
                              }));
                            }}
                            style={{
                              padding: "8px 14px",
                              fontSize: "14px",
                              cursor: "pointer",
                              backgroundColor:
                                String(selectedCountryCodes[field.sections_labels_id]?.country_id) ===
                                  String(country.country_id)
                                  ? "#f0f4ff"
                                  : "white",
                              color: "#333",
                              whiteSpace: "nowrap",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.backgroundColor = "#f5f5f5")
                            }
                            onMouseLeave={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              String(selectedCountryCodes[field.sections_labels_id]?.country_id) ===
                                String(country.country_id)
                                ? "#f0f4ff"
                                : "white")
                            }
                          >
                            +{country.country_code}&nbsp;&nbsp;{country.country_name}
                          </div>
                        ));
                      })()}
                    </div>
                  </div>
                )}
              </div>

              {/* Vertical divider */}
              <div className="phoneno_div" />

              {/* Phone number input */}
              <input
                className="Phoneno"
                type="tel"
                placeholder={field.placeholder || ""}
                value={value || ""}
                disabled={isDisabled}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^0-9]/g, "");
                  handleChange(field.sections_labels_id, val);
                  if (!val) {
                    setLivePhoneErrors((prev) => ({ ...prev, [field.sections_labels_id]: "" }));
                  } else if (!phoneRegexLive.test(val)) {
                    setLivePhoneErrors((prev) => ({
                      ...prev,
                      [field.sections_labels_id]:
                        languageId === 1
                          ? "Enter valid phone number"
                          : "Entrez un numéro de téléphone valide",
                    }));
                  } else {
                    setLivePhoneErrors((prev) => ({ ...prev, [field.sections_labels_id]: "" }));
                  }
                }}
              />
            </div>

            {livePhoneErrors[field.sections_labels_id] && (
              <small className="text-danger">
                {livePhoneErrors[field.sections_labels_id]}
              </small>
            )}
          </>
        );


      case "checkbox_declaration":
        return (
          <div
            className="form-check fst-italic d-flex align-items-start gap-2"
            style={{
              pointerEvents: isDisabled ? "none" : "auto",
              opacity: isDisabled ? 0.6 : 1,
            }}
          >
            <input
              type="checkbox"
              className="form-check-input mt-1"
              disabled={true}
              checked={value || false}
              onChange={(e) =>
                handleChange(field.sections_labels_id, e.target.checked)
              }
            />
            <p className="mb-0">
              {field.placeholder}
              {field.label_mandatory === "Yes" && (
                <span className="text-danger"> *</span>
              )}
              {personalInformationErr[field.sections_labels_id] && (
                <>
                  <br />
                  <small className="text-danger d-block mt-2">
                    {personalInformationErr[field.sections_labels_id]}
                  </small>
                </>
              )}
            </p>
          </div>
        );

      case "table":
        const allTableOptions = field.options || [];
        if (allTableOptions.length === 0) {
          return <div className="text-warning">No table columns defined</div>;
        }

        const existingTableData = Array.isArray(
          personalInformationValues[field.sections_labels_id],
        )
          ? personalInformationValues[field.sections_labels_id]
          : [];

        const numberOfRows = Math.max(
          field.sections_input_row || 1,
          existingTableData.length,
        );

        // Initialize rows if not yet set
        const tableRows = Array.from({ length: numberOfRows }).map((_, i) => {
          if (existingTableData[i]) return existingTableData[i];
          const emptyRow = {};
          allTableOptions.forEach((opt) => {
            emptyRow[opt.option] = "";
          });
          return emptyRow;
        });

        // ✅ Initialize state if empty (same as BookingIntakeForm)
        if (existingTableData.length === 0) {
          setTimeout(() => {
            setPersonalInformationValues((prev) => ({
              ...prev,
              [field.sections_labels_id]: tableRows,
            }));
          }, 0);
        }

        return (
          <div className="table-responsive">
            <table
              className="table table-bordered text-center align-middle"
              style={{
                borderCollapse: "collapse",
                minWidth: "700px",
                opacity: isDisabled ? 0.6 : 1,
                pointerEvents: isDisabled ? "none" : "auto",
              }}
            >
              <thead>
                <tr>
                  {allTableOptions.map((opt) => (
                    <th
                      key={opt.sections_options_id}
                      style={{
                        background: "#2f4363",
                        color: "#fff",
                        fontSize: "14px",
                        padding: "10px",
                      }}
                    >
                      {opt.option}
                    </th>
                  ))}
                  {isHireInCanada() && (
                    <th
                      style={{
                        background: "#2f4363",
                        color: "#fff",
                        fontSize: "14px",
                        padding: "10px",
                        width: "60px",
                      }}
                    >
                      Action
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {/* ✅ Use existingTableData from STATE, not local tableRows */}
                {(existingTableData.length > 0
                  ? existingTableData
                  : tableRows
                ).map((rowData, rowIndex) => (
                  <tr key={rowIndex}>
                    {allTableOptions.map((opt) => (
                      <td key={opt.sections_options_id}>
                        <input
                          type={isHireInCanada() ? "text" : "number"}
                          className={`form-control text-center ${!isHireInCanada() ? "hide-number-arrows" : ""
                            }`}
                          placeholder={
                            isHireInCanada()
                              ? opt.option
                              : field.placeholder || "e.g. 7.0"
                          }
                          value={rowData[opt.option] || ""}
                          disabled={isDisabled}
                          min={isHireInCanada() ? undefined : 0.1}
                          max={isHireInCanada() ? undefined : 9}
                          step={isHireInCanada() ? undefined : 0.01}
                          onChange={(e) => {
                            const value = e.target.value;

                            if (isHireInCanada()) {
                              // Allow alphabets and spaces while typing
                              if (/^[A-Za-z ]*$/.test(value)) {
                                handleTableChange(
                                  field.sections_labels_id,
                                  rowIndex,
                                  opt.option,
                                  value,
                                );
                              }
                            } else {
                              // ✅ allow decimals strictly between 0.1 and 9.9
                              const num = parseFloat(value);
                              if (value === "" || (num >= 0.1 && num <= 9.9)) {
                                handleTableChange(
                                  field.sections_labels_id,
                                  rowIndex,
                                  opt.option,
                                  value,
                                );
                              }
                            }
                          }}
                        />
                      </td>
                    ))}
                    {isHireInCanada() && (
                      <td>
                        <button
                          type="button"
                          className="btn btn-sm btn-danger"
                          // ✅ Use existingTableData.length from STATE
                          disabled={isDisabled || existingTableData.length <= 1}
                          onClick={() => {
                            if (existingTableData.length <= 1) return;
                            // ✅ Update STATE directly, same as BookingIntakeForm
                            const updated = existingTableData.filter(
                              (_, i) => i !== rowIndex,
                            );
                            setPersonalInformationValues((prev) => ({
                              ...prev,
                              [field.sections_labels_id]: updated,
                            }));
                          }}
                          title="Remove row"
                        >
                          ✕
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>

            {isHireInCanada() && (
              <div className="mt-3">
                <button
                  type="button"
                  className="btn btn-outline-success"
                  disabled={isDisabled}
                  onClick={() => {
                    // ✅ Add to STATE directly, same as BookingIntakeForm
                    const newRow = {};
                    allTableOptions.forEach((opt) => {
                      newRow[opt.option] = "";
                    });
                    setPersonalInformationValues((prev) => ({
                      ...prev,
                      [field.sections_labels_id]: [
                        ...(prev[field.sections_labels_id] || []),
                        newRow,
                      ],
                    }));
                  }}
                >
                  + Add Row
                </button>
              </div>
            )}
          </div>
        );

      /* ═══════════════════════════════════════════════════════════════════════
         IMAGE / SIGNATURE  ──  view  |  upload / re-upload  |  download
      ═══════════════════════════════════════════════════════════════════════ */
      case "image": {
        let imageUrl = "";
        if (value) {
          if (Array.isArray(value) && value.length > 0) {
            imageUrl = value[0];
          } else if (typeof value === "string") {
            if (value.startsWith('["') || value.startsWith("[")) {
              try {
                const parsed = JSON.parse(value);
                if (Array.isArray(parsed) && parsed.length > 0) imageUrl = parsed[0];
              } catch {
                imageUrl = value;
              }
            } else {
              imageUrl = value;
            }
          }
        }

        const isUploading = !!imageUploadLoading[field.sections_labels_id];
        const uploadInputId = `r-upload-${field.sections_labels_id}`;
        const isSaved = !!savedSignatures[field.sections_labels_id];

        return (
          <div className="signature-field-wrapper" style={{ opacity: isDisabled ? 0.7 : 1 }}>
            <div className="signature-main-box">

              {/* ── Upload trigger (only shown when no image exists yet) ── */}
              {!isDisabled && !imageUrl && (
                <>
                  <label
                    htmlFor={uploadInputId}
                    className="signature-upload-box"
                    style={{ cursor: isUploading ? "not-allowed" : "pointer" }}
                  >
                    <p className="signature-upload-text">
                      {languageId === 1
                        ? "Drop your files here or click to upload"
                        : "Déposez vos fichiers ici ou cliquez pour télécharger"}
                    </p>
                  </label>
                </>
              )}

              {/* ── Preview + overlay spinner + action icons ── */}
              {imageUrl ? (
                <>
                  {/* Outer Image Container */}
                  <div
                    className="signature-preview-wrapper"
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "220px",
                      borderRadius: "8px",
                      overflow: "hidden",
                      border: "1px solid #dee2e6",
                      backgroundColor: "#f8f9fa",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "8px",
                    }}
                  >
                    {/* uploading overlay */}
                    {isUploading && (
                      <div
                        style={{
                          position: "absolute",
                          inset: 0,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "rgba(255,255,255,0.75)",
                          zIndex: 2,
                          gap: "8px",
                        }}
                      >
                        <span
                          className="spinner-border"
                          role="status"
                          aria-hidden="true"
                          style={{ width: "32px", height: "32px", borderWidth: "3px" }}
                        />
                        <span style={{ fontSize: "13px", color: "#555" }}>
                          {languageId === 1 ? "Uploading..." : "Téléchargement..."}
                        </span>
                      </div>
                    )}

                    {/* Inner Container — shrinks to the image's actual rendered size */}
                    <div
                      className="signature-inner-box"
                      style={{
                        position: "relative",
                        display: "inline-flex",
                        width: "fit-content",
                        height: "fit-content",
                        maxWidth: "100%",
                        maxHeight: "100%",
                      }}
                    >
                      <img
                        src={imageUrl}
                        alt={field.label || "Signature"}
                        onClick={() => {
                          if (isUploading) return;
                          setImagePreviewModal({
                            show: true,
                            url: imageUrl,
                            label: field.label || (languageId === 1 ? "Signature" : "Signature"),
                          });
                        }}
                        title={
                          languageId === 1
                            ? "Click to preview"
                            : "Cliquez pour prévisualiser"
                        }
                        style={{
                          maxWidth: "100%",
                          maxHeight: "204px", // outer height (220) minus padding (8+8)
                          width: "auto",
                          height: "auto",
                          objectFit: "contain",
                          display: "block",
                          cursor: isUploading ? "default" : "zoom-in",
                        }}
                      />

                      {/* ── Download icon — ONLY for images already saved in the DB ── */}
                      {!isUploading && !isDisabled && isSaved && (
                        <button
                          type="button"
                          onClick={() => handleSignatureDownload(imageUrl, field.label)}
                          title={languageId === 1 ? "Download signature" : "Télécharger la signature"}
                          style={{
                            position: "absolute",
                            bottom: "4px",
                            right: "4px",
                            zIndex: 3,
                            background: "rgba(255, 255, 255, 0.85)",
                            border: "1px solid rgba(220, 53, 69, 0.3)",
                            borderRadius: "4px",
                            color: "#dc3545",
                            padding: "4px 6px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "all 0.2s",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "rgba(220, 53, 69, 0.1)";
                            e.currentTarget.style.borderColor = "rgba(220, 53, 69, 0.6)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "rgba(255, 255, 255, 0.85)";
                            e.currentTarget.style.borderColor = "rgba(220, 53, 69, 0.3)";
                          }}
                        >
                          <i
                            className="bi bi-download"
                            style={{
                              fontSize: "clamp(14px, 1.5vw, 20px)",
                              color: "#dc3545",
                              lineHeight: 1,
                            }}
                          />
                        </button>
                      )}

                      {/* ── Unsaved note — shown instead of download icon until the form is submitted ── */}
                      {!isUploading && !isDisabled && !isSaved && (
                        <span
                          style={{
                            position: "absolute",
                            bottom: "4px",
                            right: "4px",
                            zIndex: 3,
                            fontSize: "10px",
                            fontStyle: "italic",
                            color: "#888",
                            background: "rgba(255,255,255,0.9)",
                            border: "1px solid #eee",
                            borderRadius: "4px",
                            padding: "2px 6px",
                            lineHeight: 1.4,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {languageId === 1 ? "Unsaved" : "Non enregistré"}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* ── Upload button outside the image container ── */}
                  {!isUploading && !isDisabled && (
                    <div
                      style={{
                        marginTop: "clamp(6px, 1vh, 12px)",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <label
                        htmlFor={uploadInputId}
                        title={languageId === 1 ? "Upload signature" : "Télécharger la signature"}
                        style={{
                          cursor: "pointer",
                          display: "inline-flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: "6px",
                          padding: "clamp(4px, 0.6vh, 8px) clamp(10px, 1.2vw, 18px)",
                          backgroundColor: "white",
                          border: "2px solid #dc3545",
                          borderRadius: "5px",
                          color: "#dc3545",
                          fontSize: "clamp(10px, 0.8vw, 13px)",
                          fontWeight: "bold",
                          transition: "all 0.2s",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                          width: "auto",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "#dc3545";
                          e.currentTarget.style.color = "white";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "white";
                          e.currentTarget.style.color = "#dc3545";
                        }}
                      >
                        <i
                          className="bi bi-upload"
                          style={{ fontSize: "clamp(11px, 1vw, 14px)", lineHeight: 1 }}
                        />
                        <span style={{ whiteSpace: "nowrap", fontSize: "clamp(9px, 0.7vw, 12px)" }}>
                          {languageId === 1 ? "Upload" : "Télécharger"}
                        </span>
                      </label>
                    </div>
                  )}
                </>
              ) : (
                /* ── No image yet: show spinner inside upload box, or empty hint ── */
                isUploading ? (
                  <div
                    className="signature-upload-box"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      cursor: "not-allowed",
                    }}
                  >
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ width: "28px", height: "28px", borderWidth: "3px" }}
                    />
                    <span style={{ fontSize: "13px", color: "#555" }}>
                      {languageId === 1 ? "Uploading..." : "Téléchargement..."}
                    </span>
                  </div>
                ) : (
                  !isDisabled && (
                    <p className="signature-no-preview">
                      {languageId === 1 ? "No signature uploaded" : "Aucune signature téléchargée"}
                    </p>
                  )
                )
              )}
            </div>

            {/* ── Hidden file input (shared by label trigger + re-upload icon) ── */}
            {!isDisabled && (
              <input
                id={uploadInputId}
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                disabled={isUploading}
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file) handleSignatureUpload(field.sections_labels_id, file);
                  e.target.value = "";
                }}
              />
            )}

            {isDisabled && (
              <p className="text-muted small mt-1">
                <em>
                  {languageId === 1 ? "Signature is read-only" : "La signature est en lecture seule"}
                </em>
              </p>
            )}
          </div>
        );
      }

      default:
        return (
          <input
            type="text"
            className="form-control"
            value={value || ""}
            onChange={(e) =>
              handleChange(field.sections_labels_id, e.target.value)
            }
            {...commonProps}
          />
        );
    }
  };
  useEffect(() => {
    if (personalinformation.length > 0) {
      console.log(
        "Personal Information with IDs:",
        personalinformation.map((section) => ({
          section_id: section.sections_id,
          fields: (section.fields || section.data || []).map((f) => ({
            id: f.sections_labels_id,
            label: f.label,
            sections_values_id: f.sections_values_id,
            details: f.details,
          })),
        })),
      );
    }
  }, [personalinformation]);

  useEffect(() => {
    if (admin) {
      console.log("Admin data:", {
        consultation_booking_id: admin.consultation_booking_id,
        customer: admin.customer,
        sections: admin.sections,
        personalInformationValues: personalInformationValues,
      });
    }
  }, [admin, personalInformationValues]);
  useEffect(() => {
    // Log all mandatory fields and their values for debugging
    if (personalinformation.length > 0) {
      console.log("=== MANDATORY FIELDS CHECK ===");
      personalinformation.forEach((section) => {
        const fieldsArray = section.fields || section.data || [];
        fieldsArray.forEach((field) => {
          if (field.label_mandatory === "Yes") {
            const value = personalInformationValues[field.sections_labels_id];
            console.log(
              `Field: ${field.label} (ID: ${field.sections_labels_id})`,
              {
                mandatory: field.label_mandatory,
                value: value,
                isValid: value && value !== "",
              },
            );
          }
        });
      });
    }
  }, [personalinformation, personalInformationValues]);
  useEffect(() => {
    console.log("=== PERSONAL INFORMATION STRUCTURE ===");
    console.log("personalinformation length:", personalinformation.length);
    if (personalinformation.length > 0) {
      const firstSection = personalinformation[0];
      console.log("First section keys:", Object.keys(firstSection));
      console.log("Has 'data' array:", !!firstSection.data);
      console.log("Has 'fields' array:", !!firstSection.fields);

      const fieldsArray = firstSection.data || firstSection.fields || [];
      if (fieldsArray.length > 0) {
        console.log("First field sample:", fieldsArray[0]);
        console.log("Has label_mandatory:", fieldsArray[0].label_mandatory);
      }
    }
  }, [personalinformation]);
  useEffect(() => {
    console.log(
      "personalInformationValues changed:",
      personalInformationValues,
    );
  }, [personalInformationValues]);
  /* ================= RENDER ================= */

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getDateRestriction = (inputType) => {
    if (!inputType) return "none";
    const type = inputType?.toLowerCase();

    // English Previous Date
    if (type === "previous date") {
      return "previous";
    }

    // English Future Date
    if (type === "future date") {
      return "future";
    }

    // French Previous Date
    if (type === "date précédente") {
      return "previous";
    }

    // French Future Date
    if (type === "date future") {
      return "future";
    }

    // Regular Date (no restrictions)
    return "none";
  };

  // Helper to get error message based on restriction and language
  const getDateErrorMessage = (restriction, languageId) => {
    if (restriction === "previous") {
      return languageId === 1
        ? "Date cannot be in the future"
        : "La date ne peut pas être dans le futur";
    }
    if (restriction === "future") {
      return languageId === 1
        ? "Date cannot be in the past"
        : "La date ne peut pas être dans le passé";
    }
    return "";
  };

  useEffect(() => {
    const syncLabelHeights = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => { // double RAF ensures full paint
          const rows = document.querySelectorAll(".row.g-3");
          rows.forEach((row) => {
            const cols = Array.from(row.querySelectorAll(":scope > [class*='col-']"));
            if (cols.length <= 1) return;

            // Reset all labels first
            cols.forEach((col) => {
              const label = col.querySelector("label.mb-2");
              if (label) label.style.minHeight = "";
            });

            // Group by visual row using offsetTop
            const groups = {};
            cols.forEach((col) => {
              const label = col.querySelector("label.mb-2");
              if (!label) return;
              const top = Math.round(col.offsetTop);
              if (!groups[top]) groups[top] = [];
              groups[top].push(label);
            });

            // For each visual row group, sync label heights
            Object.values(groups).forEach((labels) => {
              if (labels.length <= 1) return;
              const maxHeight = Math.max(...labels.map((l) => l.offsetHeight));
              labels.forEach((label) => {
                if (label.offsetHeight < maxHeight) {
                  label.style.minHeight = `${maxHeight}px`;
                }
              });
            });
          });
        });
      });
    };

    // First render needs longer delay for fonts + layout to settle
    const t1 = setTimeout(syncLabelHeights, 300);
    const t2 = setTimeout(syncLabelHeights, 800);

    window.addEventListener("resize", syncLabelHeights);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      window.removeEventListener("resize", syncLabelHeights);
    };
  }, [personalinformation, personalInformationValues]);
  return (
    <div className="con-view-form-container">
      {loading && (
        <div className="loading-overlay">
          <Loading />
        </div>
      )}
      {/* ================= STEP 1 ================= */}
      {step === 1 && (
        <div className="con-form-container">
          <div className="newsadd-header">
            <h2 className="newsadd-title">
              {languageId === 1
                ? "Edit Consultation"
                : "Modifier la consultation"}
            </h2>
            <div className="header-buttons">
              <button
                className="cancel-btn"
                onClick={() =>
                  navigate("/ConsultationFromList", {
                    state: { pageNumber, language_id: languageId },
                  })
                }
              >
                {languageId === 1 ? "Back" : "Retour"}
              </button>
            </div>
          </div>

          <div className="intake-form">
            {/* IMMIGRATION GOAL */}
            <div className="form-group">
              <label>
                {languageId === 1
                  ? "Select your immigration goal"
                  : "Sélectionnez votre objectif d'immigration"}
              </label>

              <select
                className="form-select no-dropdown"
                value={immigrationvalue}
                onChange={Immigration}
                disabled // 👈 this makes it non-editable
              >
                <option value="">
                  {languageId === 1 ? "-- Select --" : "-- Sélectionner --"}
                </option>

                {Array.isArray(listimmigratongoal) &&
                  listimmigratongoal.map((item) => (
                    <option
                      key={item.listofservice_id}
                      value={item.listofservice_id}
                    >
                      {item.heading}
                    </option>
                  ))}
              </select>

              {immigrationErr && (
                <p className="text-danger">{immigrationErr}</p>
              )}
            </div>

            {/* CONSULTATION TYPE */}
            <div className="form-group mt-3">
              <label>
                {languageId === 1
                  ? "Consultation Type"
                  : "Type de consultation"}
              </label>
              <select
                className="form-select"
                value={hadleType}
                onChange={handleConsultationType}
              >
                <option value="">
                  {languageId === 1 ? "-- Select --" : "-- Sélectionner --"}
                </option>
                {Array.isArray(consultationtype) &&
                  consultationtype.map((item) => (
                    <option
                      key={item.consultation_type_id}
                      value={item.consultation_type_id}
                    >
                      {item.consultation_type_name}
                    </option>
                  ))}
              </select>
              {consultationErr && (
                <p className="text-danger">{consultationErr}</p>
              )}
            </div>

            {/* DATE */}
            <div className="mt-4">
              <p className="scheduledateandtime">
                {languageId === 1 ? "Schedule Date" : "Date du rendez-vous"}
              </p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateCalendar
                  value={startDate}
                  onChange={handleDateChange}
                  views={["day"]}
                  sx={calendarStyles}
                  disablePast
                />
              </LocalizationProvider>
            </div>

            {/* TIME SLOTS */}
            <div className="mt-3">
              {timeList.length > 0 && (
                <p className="time mt-2">
                  {languageId === 1 ? "Time" : "Heure"}
                </p>
              )}
              <div className="d-flex flex-wrap gap-3 col-lg-6">
                {timeList.map((item, index) => {
                  const disabled = isSlotDisabled(
                    item.start_time,
                    item.end_time,
                  );
                  return (
                    <div
                      key={index}
                      className={`card p-2 timebagroundcolour ${activeStartTime &&
                        normalizeTime(activeStartTime) ===
                        normalizeTime(item.start_time)
                        ? "active-time"
                        : disabled
                          ? "disabled-time"
                          : "cursorpointer"
                        }`}
                      onClick={() => {
                        if (!disabled) handleStartTime(item);
                      }}
                    >
                      {formatTime(item.start_time)}
                    </div>
                  );
                })}
              </div>
              {timeErr && <div className="text-danger mt-1">{timeErr}</div>}
            </div>

            {/* NEXT BUTTON */}
            <div className="next-buttons">
              <button
                type="button"
                className="cancel-btn"
                onClick={handleNextStep}
              >
                {languageId === 1 ? "Next" : "Suivant"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ================= STEP 2 ================= */}
      {step === 2 && (
        <>
          <div className="intake-header">
            <h2>
              {languageId === 1
                ? "IMMIGRATION CONSULTATION INTAKE FORM"
                : "FORMULAIRE DE DEMANDE DE CONSULTATION EN MATIÈRE D'IMMIGRATION"}
            </h2>
            <button className="cancel-btn" onClick={() => setStep(1)}>
              {languageId === 1 ? "Back" : "Retour"}
            </button>
          </div>

          <div className="mt-3 mb-4 d-flex justify-content-end">
            {amountStatus !== "Paid" &&
              hadleType !== 12 &&
              hadleType !== 13 && (
                <button
                  className="cancel-btn me-2"
                  onClick={() =>
                    setPopupbutton({
                      show: true,
                      type: "payment",
                      title: "Payment Request",
                      message: "Please complete the payment to continue.",
                    })
                  }
                >
                  {languageId === 1 ? "Payment Request" : "Demande de paiement"}
                </button>
              )}
            <button
              className="cancel-btn"
              onClick={() => {
                if (hadleType === 12 || hadleType === 13) {
                  setPopupbutton({
                    show: true,
                    type: "free-booking",
                    title: "Booking Confirmation",
                    message: "Confirm booking.",
                  });
                } else {
                  setPopupbutton({
                    show: true,
                    type: "booking",
                    title: "Booking Confirmation",
                    message: "Confirm booking after payment is received.",
                  });
                }
              }}
            >
              {languageId === 1
                ? "Booking Confirmation"
                : "Confirmation de réservation"}
            </button>
          </div>

          <div className="card rounded-3 immigrationgap shadow-sm">
            <div className="fields-info">
              <p>
                {languageId === 1
                  ? "fields marked with * are mandatory."
                  : "les champs marqués * sont obligatoires."}
              </p>
            </div>

            {/* ✅ SERVICE HEADING - Display below the mandatory fields message */}
            {serviceHeading && serviceHeading !== " " && (
              <div className="form-service-heading fs-2 base-clr mb-3 px-3">
                {serviceHeading}
              </div>
            )}

            <div className="card-body">
              {loading ? (
                <div className="text-center py-5">
                  <Loading />
                </div>
              ) : (
                Array.isArray(personalinformation) &&
                personalinformation.map((section) => {
                  // Use 'data' array (from API) or fallback to 'fields' (from item)
                  const fieldsArray = section.data || section.fields || [];

                  return (
                    <div key={section.sections_id} className="mb-4">
                      {/* ✅ SECTION TITLE */}
                     
                          <h5 className="fw-bold mb-3">
                            {section.sections_titles} :
                          </h5>

                      {/* ✅ SECTION HEADING */}
                      {section.section_heading &&
                        section.section_heading !== " " && (
                          <div
                            className="form-section-heading mb-4"
                            dangerouslySetInnerHTML={{
                              __html: section.section_heading,
                            }}
                          />
                        )}

                      <div className="row g-3">
                        {Array.isArray(fieldsArray) &&
                          fieldsArray.map((field) => {
                            const value =
                              personalInformationValues[
                              field.sections_labels_id
                              ] ??
                              field.details ??
                              "";
                            const error =
                              personalInformationErr[field.sections_labels_id];
                            const isRequired = field.label_mandatory === "Yes";

                            const columnClass = ["column-2", "colonne-2"].includes(field.columns_value)
                              ? "col-md-6"
                              : ["column-1", "colonne-1"].includes(field.columns_value) &&
                                ["table", "tableau"].includes(field.input_type?.toLowerCase())
                                ? "col-md-11"
                                : ["column-1", "colonne-1"].includes(field.columns_value) &&
                                  [
                                    "phoneno",
                                    "description",
                                    "numéro de téléphone",
                                    "briefly_description",
                                    "brièvement_description",
                                    "text with numbers",
                                    "text", "texte", "numbers", "Nombres", "radio",
                                    "texte avec des chiffres"
                                  ].includes(field.input_type?.toLowerCase())
                                  ? "col-md-6"
                                  : ["column-1", "colonne-1"].includes(field.columns_value) &&
                                    [
                                      "text",
                                      "texte",
                                      "numbers",
                                      "Nombres",
                                      "text with numbers",
                                      "texte avec des chiffres",
                                      "dropdown",
                                      "description",
                                    ].includes(normalizeInputType(field.input_type))
                                    ? "col-md-6"
                                    : "col-md-12";
                            return (
                              <div
                                key={field.sections_labels_id}
                                data-error-id={field.sections_labels_id}
                                className={`mb-3 ${columnClass}`}
                              >
                                {normalizeInputType(field.input_type) !==
                                  "checkbox_declaration" && (
                                    <label className="mb-2">
                                      {field.label}

                                      {(() => {
                                        const depOn = fieldMeta[field.sections_labels_id]?.dependent_on ?? field.dependent_on;
                                        const parentValue = personalInformationValues[depOn];

                                        let parentOptionsValue = null;
                                        if (depOn && parentValue) {
                                          parentOptionsValue = getSelectedOptionValue(depOn, parentValue);
                                        }

                                        // Field is disabled if parent exists but options_value is "No"
                                        // OR if parent has no value yet
                                        let isFieldDisabled = false;
                                        if (depOn) {
                                          if (!parentValue && parentValue !== 0) {
                                            isFieldDisabled = true;
                                          } else {
                                            isFieldDisabled = parentOptionsValue === "No";
                                          }
                                        }

                                        // Only show * if mandatory AND field is not disabled
                                        const showRequired = field.label_mandatory === "Yes" && !isFieldDisabled;

                                        return showRequired ? <span className="text-danger ms-1">*</span> : null;
                                      })()}
                                    </label>
                                  )}

                                {renderFormField(
                                  field,
                                  value,
                                  handlePersonalInformation,
                                )}

                                {error && (
                                  <div
                                    className="text-danger mt-1"
                                    style={{ fontSize: "0.85rem" }}
                                  >
                                    {error}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  );
                })
              )}

              {/* SUBMIT BUTTON */}
              <div className="d-flex justify-content-end mt-4 mb-2">
                <button
                  className="bookconsultationcontinue py-3 px-5"
                  type="button"
                  onClick={handleUpdateConsultation}
                  disabled={loading}
                >
                  {loading
                    ? "Processing..."
                    : languageId === 1
                      ? "Submit"
                      : "Soumettre"}
                </button>
              </div>

              {visiblePaymentRequests.length > 0 && (
                <>
                  <div className="mt-3 mb-3">
                    <p className="personalinformation mt-3">
                      {languageId === 1
                        ? "Payment Request Form"
                        : "Formulaire de demande de paiement"}
                    </p>
                  </div>

                  {visiblePaymentRequests.map((payment) => (
                    <div
                      key={payment.payment_request_form_id}
                      className="popup-grid1 mb-3"
                    >
                      <div>
                        <label className="form-label">
                          {languageId === 1 ? "Message" : "Message"}
                        </label>
                        <textarea value={payment.message || ""} readOnly />
                      </div>

                      <div className="col-12 col-lg-12">
                        <label className="form-label labelinput d-block">
                          {languageId === 1 ? "QR Code" : "Code QR"}
                        </label>

                        {payment.image && (
                          <div className="mt-2">
                            <img
                              src={payment.image}
                              alt="QR"
                              style={{
                                maxHeight: "120px",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </>
              )}

              {Array.isArray(admin?.payment_request_form) &&
                admin.payment_request_form.length > 0 && (
                  <>
                    <div className="mt-3 mb-3">
                      <p className="personalinformation mt-3">
                        {languageId === 1
                          ? "Booking Confirmation"
                          : "Confirmation de rendez-vous"}
                      </p>
                    </div>

                    <div className="booking-content">
                      <div className="form-group">
                        <label className="form-label">
                          {languageId === 1
                            ? "Appointment Amount"
                            : "Montant du rendez-vous"}
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          value={`$ ${totalAppointmentAmount}`}
                          readOnly
                        />
                      </div>
                    </div>
                  </>
                )}

              <>
                <div className="mt-3 mb-3">
                  <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                    <p className="personalinformation mb-0">
                      {languageId === 1 ? "Notes" : "Remarques"}
                    </p>

                    <button
                      className="cancel-btn"
                      type="button"
                      onClick={handleNote}
                    >
                      {languageId === 1 ? "Notes" : "Remarques"}
                    </button>
                  </div>
                  {notesListLoading ? (
                    <p>{languageId === 1 ? "Loading..." : "Chargement..."}</p>
                  ) : notesList.length > 0 ? (
                    <ul className="list-group">
                      {notesList.map((note) => (
                        <li
                          key={note.consultation_notes_id}
                          className="list-group-item justify-content-between align-items-start"
                        >
                          <div className="flex-grow-1 me-3">
                            <label
                              className="form-check-label"
                              htmlFor={`note-${note.consultation_notes_id}`}
                            >
                              {note.notes}
                            </label>
                          </div>
                          <div className="text-muted">
                            {formatNoteDate(note.createdAt)}
                          </div>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="no-faq-text">
                      {languageId === 1
                        ? "No notes found"
                        : "Aucune note trouvée"}
                    </p>
                  )}
                </div>
              </>
            </div>
          </div>
        </>
      )}
      {/* SUCCESS / ERROR POPUP */}
      {popup.show && (
        <div className="popup-overlay">
          <div className={`popup-box popup-${popup.type}`}>
            <h3>{popup.title}</h3>
            <p>{popup.message}</p>
            <div className="popup-buttons">
              <button
                className="btn ok-btn"
                onClick={() => {
                  setPopup({ show: false });
                  if (popup.type === "success") {
                    setLoading(true);
                    navigate("/ConsultationFromList", {
                      state: { pageNumber },
                    });
                  }
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* NOTES POPUP */}
      {showNotesPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h5 className="mb-3">
              {languageId === 1 ? "Add Notes" : "Ajouter des notes"}
            </h5>
            <textarea
              className="form-control"
              rows="4"
              value={notesText}
              placeholder={
                languageId === 1 ? "Enter notes here" : "Entrez les notes ici"
              }
              onChange={(e) => {
                setNotesText(e.target.value);
                setNotesError("");
              }}
            />
            {notesError && (
              <div className="text-danger mt-1" style={{ fontSize: "0.85rem" }}>
                {notesError}
              </div>
            )}
            <div className="d-flex justify-content-end gap-2 mt-3">
              <button
                className="send-btn"
                onClick={() => setShowNotesPopup(false)}
              >
                {languageId === 1 ? "Cancel" : "Annuler"}
              </button>
              <button className="send-btn" onClick={submitNotes}>
                {languageId === 1 ? "Save" : "Enregistrement"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* PAYMENT / BOOKING POPUP */}
      {popupbutton.show && (
        <div className="popup-overlay1">
          <div className={`popup-box1 ${loading ? "popup-loading" : ""}`}>
            {loading ? (
              <div className="loader-wrapper">
                <Loading />
              </div>
            ) : (
              <>
                {/* PAYMENT */}
                {popupbutton.type === "payment" && (
                  <div>
                    <h3>
                      {languageId === 1
                        ? "Payment Request Form"
                        : "Formulaire de demande de paiement"}
                    </h3>
                    <div className="popup-grid1">
                      <div>
                        <label className="form-label">
                          {languageId === 1 ? "Message" : "Message"}
                          <span className="text-danger ms-1">*</span>
                        </label>
                        <textarea
                          placeholder={
                            languageId === 1
                              ? "Enter your message here"
                              : "Entrez votre message ici"
                          }
                          value={paymentMessage}
                          onChange={(e) => {
                            setPaymentMessage(e.target.value);
                            setPaymentErrors((prev) => ({
                              ...prev,
                              message: "",
                            }));
                          }}
                        />
                        {paymentErrors.message && (
                          <div
                            className="text-danger mt-1"
                            style={{ fontSize: "0.85rem" }}
                          >
                            {paymentErrors.message}
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-lg-12">
                        <label className="form-label labelinput">
                          {languageId === 1
                            ? "Upload QR code"
                            : "Télécharger le code QR"}
                          <span className="text-danger ms-1">*</span>
                        </label>
                        <div className="file-upload-box text-center p-3">
                          <label>
                            <input
                              type="file"
                              style={{ display: "none" }}
                              onChange={handlePaymentImageUpload}
                            />
                            {paymentImagePreview ? (
                              <img
                                src={paymentImagePreview}
                                alt="Uploaded"
                                style={{
                                  maxHeight: "100px",
                                  objectFit: "contain",
                                }}
                              />
                            ) : (
                              <img src={UploadIcon} alt="upload" />
                            )}
                          </label>
                          <div className="upload-instructions mt-2">
                            <p className="mb-1 inputclssname">
                              {languageId === 1
                                ? "Click to upload"
                                : "Cliquez pour télécharger"}
                            </p>
                          </div>
                        </div>
                        {paymentErrors.image && (
                          <div
                            className="text-danger mt-2"
                            style={{ fontSize: "0.85rem" }}
                          >
                            {paymentErrors.image}
                          </div>
                        )}
                      </div>
                    </div>
                    <button className="send-btn" onClick={sendPaymentRequest}>
                      {languageId === 1 ? "Send" : "Envoyer"}
                    </button>
                  </div>
                )}

                {/* PAID BOOKING (with amount) */}
                {popupbutton.type === "booking" && (
                  <div className="Booking">
                    <h3>
                      {languageId === 1
                        ? "Booking Confirmation"
                        : "Confirmation de rendez-vous"}
                    </h3>
                    <div className="booking-content">
                      <div className="form-group">
                        <label className="form-label">
                          {languageId === 1
                            ? "Appointment Amount"
                            : "Montant du rendez-vous"}
                          <span className="text-danger ms-1">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${bookingErrors.amount ? "is-invalid" : ""}`}
                          placeholder="$"
                          value={appointmentAmount}
                          onChange={(e) => {
                            setAppointmentAmount(e.target.value);
                            setBookingErrors((prev) => ({
                              ...prev,
                              amount: "",
                            }));
                          }}
                        />
                        {bookingErrors.amount && (
                          <div
                            className="text-danger mt-1"
                            style={{ fontSize: "0.85rem" }}
                          >
                            {bookingErrors.amount}
                          </div>
                        )}
                      </div>
                      <div className="checkbox booking-checkbox">
                        <div className="checkbox-label">
                          <input
                            type="checkbox"
                            id="amountReceived"
                            checked={amountReceived}
                            onChange={(e) => {
                              setAmountReceived(e.target.checked);
                              setBookingErrors((prev) => ({
                                ...prev,
                                amountReceived: "",
                              }));
                            }}
                          />
                          <label htmlFor="amountReceived">
                            {languageId === 1
                              ? "Appointment Amount Received "
                              : "Montant du rendez-vous reçu "}
                          </label>
                        </div>
                        <span className="text-danger">*</span>
                      </div>
                      {bookingErrors.amountReceived && (
                        <div
                          className="text-danger mt-1"
                          style={{ fontSize: "0.85rem" }}
                        >
                          {bookingErrors.amountReceived}
                        </div>
                      )}
                    </div>
                    <button
                      className="send-btn"
                      onClick={handleConfirmPayment}
                      disabled={loading}
                    >
                      {languageId === 1 ? "Confirm" : "Confirmer"}
                    </button>
                  </div>
                )}

                {/* FREE BOOKING (type 12 & 13) - ONLY CONFIRMATION CHECKBOX */}
                {popupbutton.type === "free-booking" && (
                  <div className="Booking">
                    <h3>
                      {languageId === 1
                        ? "Booking Confirmation"
                        : "Confirmation de rendez-vous"}
                    </h3>
                    <div className="booking-content">
                      <div className="checkbox booking-checkbox">
                        <div className="checkbox-label">
                          <input
                            type="checkbox"
                            id="confirmBooking"
                            checked={amountReceived}
                            onChange={(e) => {
                              setAmountReceived(e.target.checked);
                              setBookingErrors((prev) => ({
                                ...prev,
                                amountReceived: "",
                              }));
                            }}
                          />
                          <label htmlFor="confirmBooking">
                            {languageId === 1
                              ? "Are you sure to confirm this booking?"
                              : "Êtes-vous sûr de confirmer ce rendez-vous?"}
                          </label>
                        </div>
                        <span className="text-danger">*</span>
                      </div>
                      {bookingErrors.amountReceived && (
                        <div
                          className="text-danger mt-1"
                          style={{ fontSize: "0.85rem" }}
                        >
                          {bookingErrors.amountReceived}
                        </div>
                      )}
                    </div>
                    <button
                      className="send-btn"
                      onClick={handleConfirmPayment}
                      disabled={loading}
                    >
                      {languageId === 1 ? "Confirm" : "Confirmer"}
                    </button>
                  </div>
                )}
              </>
            )}
            <button
              className="close-btn"
              onClick={() => {
                resetPopupFormData();
                setPopupbutton({ ...popupbutton, show: false });
              }}
            >
              ✕
            </button>
          </div>
        </div>
      )}

  
 {/* ================= SIGNATURE IMAGE PREVIEW (LIGHTBOX) ================= */}
{imagePreviewModal.show && (
  <div
    className="popup-overlay"
    onClick={() => setImagePreviewModal({ show: false, url: "", label: "" })}
    style={{
      position: "fixed",
      inset: 0,
      zIndex: 2000,
      background: "rgba(0,0,0,0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "20px",
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        position: "relative",
        background: "#fff",
        borderRadius: "10px",
        padding: "16px",
        maxWidth: "90vw",
        maxHeight: "90vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
        // FIXED CONTAINER SIZE
        width: "600px",
        height: "500px",
      }}
    >
      <button
        type="button"
        onClick={() => setImagePreviewModal({ show: false, url: "", label: "" })}
        aria-label="Close preview"
        style={{
          position: "absolute",
          top: "8px",
          right: "8px",
          background: "rgba(0,0,0,0.06)",
          border: "none",
          borderRadius: "50%",
          width: "32px",
          height: "32px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          fontSize: "16px",
          color: "#333",
          lineHeight: 1,
          zIndex: 10,
        }}
      >
        ✕
      </button>

      {/* WRAPPER for image centering */}
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <img
          src={imagePreviewModal.url}
          alt={imagePreviewModal.label || "Signature preview"}
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            width: "auto",
            height: "auto",
            objectFit: "contain",
            borderRadius: "6px",
          }}
        />
      </div>
    </div>
  </div>
)}
 
    </div>
  );
};

export default ConsultationEdit;